(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4374);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; },
  "getInitialFilterParams": function() { return /* binding */ getInitialFilterParams; },
  "getInitialSearchId": function() { return /* binding */ getInitialSearchId; },
  "setInitialSearchState": function() { return /* binding */ setInitialSearchState; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
// EXTERNAL MODULE: ./node_modules/@themuse/experiment-client/build/index.js
var build = __webpack_require__(6680);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var snowplow_js_client_build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/utils/tracking.tsx + 1 modules
var tracking = __webpack_require__(5969);
// EXTERNAL MODULE: ./src/hooks/UserContext.tsx + 1 modules
var UserContext = __webpack_require__(2344);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
;// CONCATENATED MODULE: ./src/interfaces/context/searchContextInterfaces.ts
var LocationActionTypes;
(function(LocationActionTypes) {
    LocationActionTypes["updateLocation"] = "update_location";
    LocationActionTypes["updateLocationSuggestions"] = "update_location_suggestions";
    LocationActionTypes["resetLocation"] = "reset_location";
})(LocationActionTypes || (LocationActionTypes = {}));
var CompanyActionTypes;
(function(CompanyActionTypes) {
    CompanyActionTypes["updateCompany"] = "update_company";
    CompanyActionTypes["updateCompanySuggestions"] = "update_company_suggestions";
    CompanyActionTypes["resetCompany"] = "reset_company";
})(CompanyActionTypes || (CompanyActionTypes = {}));
var FiltersActionTypes;
(function(FiltersActionTypes) {
    FiltersActionTypes["updateFilter"] = "update_filter";
    FiltersActionTypes["resetAllFilters"] = "reset_all_filters";
})(FiltersActionTypes || (FiltersActionTypes = {}));
var KeywordActionTypes;
(function(KeywordActionTypes) {
    KeywordActionTypes["updateKeyword"] = "update_keyword";
    KeywordActionTypes["resetKeyword"] = "reset_keyword";
})(KeywordActionTypes || (KeywordActionTypes = {}));
var UserInteractionActionTypes;
(function(UserInteractionActionTypes) {
    UserInteractionActionTypes["updateJobTileViews"] = "update_job_tile_views";
    UserInteractionActionTypes["updateFilterInteraction"] = "update_filter_interaction";
    UserInteractionActionTypes["resetJobTileViews"] = "reset_job_tile_views";
})(UserInteractionActionTypes || (UserInteractionActionTypes = {}));
var UrlActionTypes;
(function(UrlActionTypes) {
    UrlActionTypes["updateUrl"] = "update_url";
})(UrlActionTypes || (UrlActionTypes = {}));
var WindowLocationActionTypes;
(function(WindowLocationActionTypes) {
    WindowLocationActionTypes["updateWindowLocation"] = "update_window_location";
})(WindowLocationActionTypes || (WindowLocationActionTypes = {}));
var SearchIdActionTypes;
(function(SearchIdActionTypes) {
    SearchIdActionTypes["updateSearchId"] = "update_search_id";
})(SearchIdActionTypes || (SearchIdActionTypes = {}));

;// CONCATENATED MODULE: ./src/reducers/locationReducer.ts



var defaultState = {
    userInputValue: "",
    userSelectedLocation: null,
    locationSuggestions: []
};
var locationReducer = function(state, action) {
    var defaultLocation = {
        label: "",
        latitude: null,
        longitude: null,
        value: "",
        remote_work_location_type: null
    };
    switch(action.type){
        case LocationActionTypes.updateLocation:
            {
                var ref, ref1, ref2, ref3, ref4;
                var userInputValue = ((ref = action.payload) === null || ref === void 0 ? void 0 : ref.userInputValue) === "" ? "" : action.payload.userInputValue;
                var userSelectedLocation = ((ref1 = action.payload) === null || ref1 === void 0 ? void 0 : ref1.userSelectedLocation) || defaultLocation;
                if (((ref2 = action.payload) === null || ref2 === void 0 ? void 0 : ref2.userInputValue) === "Flexible / Remote") {
                    userInputValue = "Remote / Flexible";
                }
                if (((ref3 = action.payload) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.userSelectedLocation) === null || ref4 === void 0 ? void 0 : ref4.value) === "Flexible / Remote") {
                    userSelectedLocation = {
                        label: "Remote / Flexible",
                        latitude: null,
                        longitude: null,
                        value: "Remote / Flexible",
                        remote_work_location_type: "virtual"
                    };
                }
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    userInputValue: userInputValue,
                    userSelectedLocation: userSelectedLocation
                });
            }
        case LocationActionTypes.updateLocationSuggestions:
            {
                var updatedState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    locationSuggestions: action.payload.locationSuggestions
                });
                return updatedState;
            }
        case LocationActionTypes.resetLocation:
            {
                return defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/companyReducer.ts



var companyReducer_defaultState = {
    userInputValue: "",
    userSelectedCompany: null,
    companySuggestions: []
};
var companyReducer = function(state, action) {
    switch(action.type){
        case CompanyActionTypes.updateCompany:
            {
                var updatedState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    userInputValue: action.payload.userInputValue === null ? "" : action.payload.userInputValue,
                    userSelectedCompany: action.payload.userSelectedCompany
                });
                return updatedState;
            }
        case CompanyActionTypes.updateCompanySuggestions:
            {
                var updatedState1 = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    companySuggestions: action.payload.companySuggestions
                });
                return updatedState1;
            }
        case CompanyActionTypes.resetCompany:
            {
                return companyReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/keywordReducer.ts


var keywordReducer_defaultState = {
    userInputValue: "",
    userSelectedKeyword: null
};
var keywordReducer = function(state, action) {
    switch(action.type){
        case KeywordActionTypes.updateKeyword:
            {
                var updatedState = (0,_object_spread/* default */.Z)({}, state, action.payload);
                return updatedState;
            }
        case KeywordActionTypes.resetKeyword:
            {
                return keywordReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/filtersReducer.ts


var filtersReducer_defaultState = {
    category: [],
    industry: [],
    experienceLevel: [],
    perks: [],
    companySize: [],
    radius: "",
    postedDateRange: "",
    companyLeadership: []
};
var filtersReducer = function(state, action) {
    switch(action.type){
        case FiltersActionTypes.updateFilter:
            {
                var updatedState = (0,_object_spread/* default */.Z)({}, state, action.payload);
                return updatedState;
            }
        case FiltersActionTypes.resetAllFilters:
            {
                return filtersReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./src/reducers/userInteractionsReducer.ts




var userInteractionsReducer = function(state, action) {
    switch(action.type){
        case UserInteractionActionTypes.updateJobTileViews:
            {
                var updatedState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    tilesViewedJobIds: (0,_to_consumable_array/* default */.Z)(state.tilesViewedJobIds).concat((0,_to_consumable_array/* default */.Z)(action.payload.tilesViewedJobIds))
                });
                return updatedState;
            }
        case UserInteractionActionTypes.resetJobTileViews:
            {
                var updatedState1 = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    tilesViewedJobIds: []
                });
                return updatedState1;
            }
        case UserInteractionActionTypes.updateFilterInteraction:
            {
                var updatedState2 = (0,_object_spread/* default */.Z)({}, state, action.payload);
                return updatedState2;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/urlReducer.ts

var urlReducer = function(state, action) {
    switch(action.type){
        case UrlActionTypes.updateUrl:
            {
                return action.payload;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/searchIdReducer.ts

var searchIdReducer = function(state, action) {
    switch(action.type){
        case SearchIdActionTypes.updateSearchId:
            return action.payload;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/utils/reducers.ts
var reducers = __webpack_require__(5823);
;// CONCATENATED MODULE: ./src/hooks/SearchContext.tsx













var defaultSearchState = {
    location: {
        userInputValue: "",
        userSelectedLocation: {
            label: "",
            latitude: null,
            longitude: null,
            value: "",
            remote_work_location_type: null
        },
        locationSuggestions: []
    },
    company: {
        userInputValue: "",
        userSelectedCompany: null,
        companySuggestions: []
    },
    keyword: {
        userInputValue: "",
        userSelectedKeyword: null
    },
    filters: {
        category: [],
        industry: [],
        experienceLevel: [],
        perks: [],
        companySize: [],
        companyLeadership: []
    },
    userInteractions: {
        tilesViewedJobIds: []
    },
    url: "",
    preference: "",
    searchId: "",
    ctsEnabled: false
};
var SearchStateContext = /*#__PURE__*/ react.createContext(defaultSearchState);
var SearchDispatchContext = /*#__PURE__*/ react.createContext(undefined);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchProvider>
 *   <Component />
 * </SearchProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useSearchDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ var SearchProvider = function(props) {
    var children = props.children, location = props.location, company = props.company, keyword = props.keyword, filters = props.filters, userInteractions = props.userInteractions, preference = props.preference, searchId = props.searchId, ctsEnabled = props.ctsEnabled;
    var ref = (0,_sliced_to_array/* default */.Z)((0,reducers/* useCombinedReducers */.F)({
        location: react.useReducer(locationReducer, (0,_object_spread/* default */.Z)({}, defaultSearchState.location, location)),
        company: react.useReducer(companyReducer, (0,_object_spread/* default */.Z)({}, defaultSearchState.company, company)),
        keyword: react.useReducer(keywordReducer, (0,_object_spread/* default */.Z)({}, defaultSearchState.keyword, keyword)),
        filters: react.useReducer(filtersReducer, (0,_object_spread/* default */.Z)({}, defaultSearchState.filters, filters)),
        userInteractions: react.useReducer(userInteractionsReducer, (0,_object_spread/* default */.Z)({}, defaultSearchState.userInteractions, userInteractions)),
        url: react.useReducer(urlReducer, defaultSearchState.url),
        searchId: react.useReducer(searchIdReducer, searchId)
    }), 2), state = ref[0], dispatch = ref[1];
    var searchState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        preference: preference !== null && preference !== void 0 ? preference : defaultSearchState.preference,
        ctsEnabled: ctsEnabled === true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStateContext.Provider, {
        value: searchState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useSearchState = function() {
    var context = react.useContext(SearchStateContext);
    if (context === undefined) {
        throw new Error("useSearchState must be used within the SearchProvider");
    }
    return context;
};
var useSearchDispatch = function() {
    var context = react.useContext(SearchDispatchContext);
    if (context === undefined) {
        throw new Error("useSearchDispatch must be used within the SearchProvider");
    }
    return context;
};
SearchProvider.displayName = "SearchProvider";
useSearchState.displayName = "useSearchState";
useSearchDispatch.displayName = "useSearchDispatch";


;// CONCATENATED MODULE: ./src/hooks/WindowLocationContext.tsx






var defaultWindowLocationState = {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    port: "",
    protocol: "",
    search: ""
};
var windowLocationReducer = function(state, action) {
    switch(action.type){
        case WindowLocationActionTypes.updateWindowLocation:
            {
                var ref = window === null || window === void 0 ? void 0 : window.location, hash = ref.hash, host = ref.host, hostname = ref.hostname, href = ref.href, origin = ref.origin, pathname = ref.pathname, port = ref.port, protocol = ref.protocol, search = ref.search;
                return (0,_object_spread/* default */.Z)({}, state, {
                    hash: hash,
                    host: host,
                    hostname: hostname,
                    href: href,
                    origin: origin,
                    pathname: pathname,
                    port: port,
                    protocol: protocol,
                    search: search
                });
            }
        default:
            {
                throw new Error("Unhandled action: ".concat(action));
            }
    }
};
var WindowLocationContext = /*#__PURE__*/ react.createContext(defaultWindowLocationState);
var WindowLocationDispatchContext = /*#__PURE__*/ react.createContext(undefined);
var WindowLocationProvider = function(param) {
    var children = param.children;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useReducer(windowLocationReducer, defaultWindowLocationState), 2), state = ref[0], dispatch = ref[1];
    var url = useSearchState().url;
    (0,react.useEffect)(function() {
        dispatch({
            type: WindowLocationActionTypes.updateWindowLocation,
            payload: window.location
        });
    }, [
        url
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowLocationContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowLocationDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useWindowLocationState = function() {
    var context = react.useContext(WindowLocationContext);
    if (context === undefined) {
        throw new Error("useWindowLocationState must be used within the WindowLocationProvider");
    }
    return context;
};
var useWindowLocationDispatch = function() {
    var context = React.useContext(WindowLocationDispatchContext);
    if (context === undefined) {
        throw new Error("useWindowLocationDispatch must be used within the WindowLocationProvider");
    }
    return context;
};


// EXTERNAL MODULE: ./src/utils/searchFacetItems.ts
var searchFacetItems = __webpack_require__(4299);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
;// CONCATENATED MODULE: ./src/utils/searchFacets.ts






/**
 * Default values for radio type filters will most likely be an empty string,
 * but we want to use a more descriptive value for oskar tracking.
 */ var defaultRadioValues = {
    radius: "Anywhere",
    postedDateRange: "Anytime"
};
/**
 * Returns a default value for radio type facets
 */ var getRadioFacetValue = function(field, value) {
    if (value === "" && field in defaultRadioValues) {
        return defaultRadioValues[field];
    }
    return value;
};
var getFilterItems = function(filterItems, selectedFilters, fieldType) {
    var items = filterItems.map(function(item) {
        var ref;
        var isNested = item && "items" in item && (item === null || item === void 0 ? void 0 : (ref = item.items) === null || ref === void 0 ? void 0 : ref.length);
        var defaultChecked = fieldType === "checkbox" ? selectedFilters && selectedFilters.includes(item.value) || false : selectedFilters === item.value;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
            defaultChecked: defaultChecked,
            items: isNested ? getFilterItems(item.items, selectedFilters, fieldType) : []
        });
    });
    return items;
};
var getFacetPropsOnChange = function(param) {
    var userInputFilterName = param.userInputFilterName, filters = param.filters, dispatch = param.dispatch;
    return {
        onChange: function(listItem) {
            var filterValue = listItem.value;
            var updatedFilterValues = [];
            var selectedFilterValues = filters[userInputFilterName];
            if (selectedFilterValues) {
                if (selectedFilterValues.includes(filterValue)) {
                    updatedFilterValues = selectedFilterValues.filter(function(value) {
                        return value && value !== filterValue;
                    });
                } else {
                    updatedFilterValues = (0,_to_consumable_array/* default */.Z)(selectedFilterValues).concat([
                        filterValue
                    ]);
                }
            } else {
                updatedFilterValues = [
                    filterValue
                ];
            }
            dispatch({
                type: FiltersActionTypes.updateFilter,
                payload: (0,_define_property/* default */.Z)({}, userInputFilterName, updatedFilterValues)
            });
            dispatch({
                type: UserInteractionActionTypes.updateFilterInteraction,
                payload: {
                    mobileClearAllClickedAt: null,
                    desktopClearAllClickedAt: null,
                    individualFilterClearedAt: null
                }
            });
        }
    };
};
var getRadioFacetPropsOnChange = function(param) {
    var userInputFilterName = param.userInputFilterName, dispatch = param.dispatch;
    return {
        onChange: function(listItem) {
            dispatch({
                type: FiltersActionTypes.updateFilter,
                payload: (0,_define_property/* default */.Z)({}, userInputFilterName, listItem.value)
            });
            dispatch({
                type: UserInteractionActionTypes.updateFilterInteraction,
                payload: {
                    individualFilterClearedAt: null,
                    mobileClearAllClickedAt: null,
                    desktopClearAllClickedAt: null
                }
            });
        }
    };
};
/**
 * Get props for filters
 */ var getFacetProps = function(itemProps) {
    var ref;
    var _disableOnCompanySelect = itemProps.disableOnCompanySelect, disableOnCompanySelect = _disableOnCompanySelect === void 0 ? false : _disableOnCompanySelect, labelText = itemProps.labelText, fieldType = itemProps.fieldType, _defaultValue = itemProps.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, searchFilterItems = itemProps.searchFilterItems, userInputFilterName = itemProps.userInputFilterName, filters = itemProps.filters, company = itemProps.company, dispatch = itemProps.dispatch;
    var selectedFilters = filters[userInputFilterName];
    var filterItems = getFilterItems(searchFilterItems, selectedFilters, fieldType);
    var facetPropsCallbacks = fieldType === "checkbox" ? getFacetPropsOnChange({
        userInputFilterName: userInputFilterName,
        filters: filters,
        dispatch: dispatch
    }) : getRadioFacetPropsOnChange({
        userInputFilterName: userInputFilterName,
        dispatch: dispatch
    });
    return (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        fieldType: fieldType,
        items: filterItems,
        label: labelText
    }, facetPropsCallbacks), {
        onClear: function() {
            if ((0,browser/* isMobile */.tq)()) {
                dispatch({
                    type: UserInteractionActionTypes.updateFilterInteraction,
                    payload: {
                        individualFilterClearedAt: Date.now(),
                        mobileClearAllClickedAt: null,
                        desktopClearAllClickedAt: null
                    }
                });
                dispatch({
                    type: FiltersActionTypes.updateFilter,
                    payload: (0,_define_property/* default */.Z)({}, userInputFilterName, defaultValue || [])
                });
            }
        },
        onSave: function() {
            if ((0,browser/* isMobile */.tq)()) {
                dispatch({
                    type: UserInteractionActionTypes.updateFilterInteraction,
                    payload: {
                        individualFilterClearedAt: null,
                        mobileClearAllClickedAt: null,
                        desktopClearAllClickedAt: null
                    }
                });
            }
        }
    }), disableOnCompanySelect && {
        disabled: !!(company === null || company === void 0 ? void 0 : (ref = company.userSelectedCompany) === null || ref === void 0 ? void 0 : ref.value)
    });
};
/**
 * Returns selected filters count
 *
 * Remote checkbox updates the location reducer instead of the filters reducer,
 * so we need to check the remote_work_location_type value.
 *
 */ var getSelectedFiltersCount = function(filters, remoteLocationType) {
    var filterCount = Object.values(filters).reduce(function(accumulator, value) {
        if (!Array.isArray(value) && !!value) {
            return accumulator + 1;
        }
        if (Array.isArray(value)) {
            return accumulator + value.length;
        }
        return accumulator;
    }, 0);
    // Account for the remote checkbox in the filter count
    if (remoteLocationType === "virtual") {
        filterCount += 1;
    }
    return filterCount;
};
var getFacetValuesFromFacetItems = function(filterParamValue, facetItems) {
    var splitValues = decodeURIComponent(filterParamValue).split(",");
    return splitValues.map(function(elem) {
        var facetItem = facetItems.find(function(item) {
            return item.value.toLowerCase() === elem.toLowerCase();
        });
        return facetItem ? facetItem.value : null;
    }).filter(function(elem) {
        return elem !== null;
    });
};

// EXTERNAL MODULE: ./src/utils/featureFlags.ts
var featureFlags = __webpack_require__(7601);
;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx






var defaultFeatureFlagsState = function() {
    var flags = (0,featureFlags/* getFeatureFlags */.BZ)();
    return Object.keys(flags).reduce(function(featureFlags, featureFlag) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, featureFlags), (0,_define_property/* default */.Z)({}, featureFlag, false));
    }, {});
};
var FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState());
var FeatureFlagsProvider = function(props) {
    var featureFlags = props.featureFlags, children = props.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
var useFeatureFlagsState = function() {
    var context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";


;// CONCATENATED MODULE: ./src/hooks/SearchFacetsContext.tsx


var defaultSearchFacetsState = {
    companyFacets: {
        industries: [],
        diversity_and_inclusion_attributes: [],
        perks_and_benefits: {}
    }
};
var SearchFacetsStateContext = /*#__PURE__*/ react.createContext(defaultSearchFacetsState);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchFacetProvider>
 *   <Component />
 * </SearchFacetProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchFacetsState();
 * ```
 */ var SearchFacetsProvider = function(props) {
    var children = props.children, companyFacets = props.companyFacets;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFacetsStateContext.Provider, {
        value: {
            companyFacets: companyFacets
        },
        children: children
    });
};
var useSearchFacetsState = function() {
    var context = react.useContext(SearchFacetsStateContext);
    if (context === undefined) {
        throw new Error("useSearchFacetsState must be used within the SearchFacetsProvider.");
    }
    return context;
};
SearchFacetsProvider.displayName = "SearchFacetsProvider";
useSearchFacetsState.displayName = "useSearchFacetsState";


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/hooks/SearchResultsContext.tsx





var SearchResultsStateContext = /*#__PURE__*/ react.createContext(undefined);
var SearchResultsDispatchContext = /*#__PURE__*/ react.createContext(undefined);
var searchResultsReducer = function(state, action) {
    switch(action.type){
        case "update_results":
            {
                return (0,_object_spread/* default */.Z)({}, state, action.payload.values);
            }
        default:
            {
                throw new Error("Unhandled action: ".concat(action));
            }
    }
};
/**
 * Search Results Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchResultsProvider>
 *   <Component />
 * </SearchResultsProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchResultsState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useSearchResultsDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ var SearchResultsProvider = function(_param) {
    var children = _param.children, initialState = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useReducer(searchResultsReducer, initialState), 2), state = ref[0], dispatch = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
var useSearchResultsState = function() {
    var context = react.useContext(SearchResultsStateContext);
    if (context === undefined) {
        throw new Error("useSearchResultsState must be used within the SearchResultsProvider");
    }
    return context;
};
var useSearchResultsDispatch = function() {
    var context = react.useContext(SearchResultsDispatchContext);
    if (context === undefined) {
        throw new Error("useSearchResultsDispatch must be used within the SearchResultsProvider");
    }
    return context;
};
SearchResultsProvider.displayName = "SearchResultsProvider";
useSearchResultsState.displayName = "useSearchResultsState";
useSearchResultsDispatch.displayName = "useSearchResultsDispatch";


// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
;// CONCATENATED MODULE: ./src/components/header/Seo.tsx

/* eslint-disable max-len */ 




var Seo = function(params) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = useSearchState(), company = ref6.company, keyword = ref6.keyword, location = ref6.location, filters = ref6.filters;
    var searchUrl = params.searchUrl;
    var canonical = (0,strings/* getCanonicalUrl */.Z2)(searchUrl);
    var category = (filters === null || filters === void 0 ? void 0 : filters.category.length) === 1 ? filters === null || filters === void 0 ? void 0 : filters.category[0] : null;
    var totalCount = useSearchResultsState().totalCount;
    var seoTitle = (0,strings/* getSearchSeoTitle */.Y8)(location === null || location === void 0 ? void 0 : (ref = location.userSelectedLocation) === null || ref === void 0 ? void 0 : ref.label, (0,strings/* unSlugify */.A$)(keyword === null || keyword === void 0 ? void 0 : (ref1 = keyword.userSelectedKeyword) === null || ref1 === void 0 ? void 0 : ref1.label), company === null || company === void 0 ? void 0 : (ref2 = company.userSelectedCompany) === null || ref2 === void 0 ? void 0 : ref2.label, category, totalCount);
    var title = "".concat(seoTitle.suffix, " | The Muse");
    var description = (0,strings/* getSearchSeoDescription */.vU)(location === null || location === void 0 ? void 0 : (ref3 = location.userSelectedLocation) === null || ref3 === void 0 ? void 0 : ref3.label, (0,strings/* unSlugify */.A$)(keyword === null || keyword === void 0 ? void 0 : (ref4 = keyword.userSelectedKeyword) === null || ref4 === void 0 ? void 0 : ref4.label), company === null || company === void 0 ? void 0 : (ref5 = company.userSelectedCompany) === null || ref5 === void 0 ? void 0 : ref5.label, category, totalCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: canonical ? "index,follow" : "noindex,follow"
            }, "robots"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonical
            }, "og:url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonical
            }, "canonical")
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/main.js + 281 modules
var main = __webpack_require__(4989);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/index.tsx + 10 modules
var Icons = __webpack_require__(4158);
;// CONCATENATED MODULE: ./src/utils/searchFacetsTracking.ts



/**
 * Map search filter field names to oskar tracking fields.
 *
 * [SearchFilters.<type>]: <Oskar tracking field>
 */ var oskarFieldMapping = {
    companySize: "company_size",
    experienceLevel: "job_level",
    industry: "industry",
    perks: "perks_and_benefits",
    category: "job_categories",
    work_location: "remote_work_location_type",
    radius: "radius",
    postedDateRange: "date_posted",
    companyLeadership: "company_leadership",
    diversityAndInclusion: "diversity_and_inclusion"
};
var snowplowFilterNameMap = new Map();
snowplowFilterNameMap.set("category", "Job Category").set("companyLeadership", "Diversity & Inclusion").set("companySize", "Company Size").set("experienceLevel", "Experience Level").set("industry", "Company Industry").set("perks", "Perks & Benefits").set("postedDateRange", "Date Posted").set("radius", "Search Radius").set("company", "Company Name").set("location", "Location");
/**
 * Triggers muse track events for Applied / Removed filters.
 *
 * To support additional facets, add field mapping to oskarFieldMapping.
 */ var trackFacets = function(eventName, filterSource, sourceFilters, diffFilters) {
    Object.keys(sourceFilters).forEach(function(key) {
        if (Array.isArray(sourceFilters[key])) {
            sourceFilters[key].forEach(function(filterItem) {
                var ref;
                if (oskarFieldMapping[key] && !((ref = diffFilters[key]) === null || ref === void 0 ? void 0 : ref.includes(filterItem))) {
                    (0,tracking/* museTrack */.YU)(eventName, {
                        source: "search-listing",
                        model_type: "jobs",
                        filter_source: filterSource,
                        name: oskarFieldMapping[key],
                        value: filterItem
                    });
                }
            });
        }
        if (typeof sourceFilters[key] === "string") {
            if (sourceFilters[key] !== diffFilters[key]) {
                (0,tracking/* museTrack */.YU)(eventName, {
                    source: "search-listing",
                    model_type: "jobs",
                    filter_source: filterSource,
                    name: oskarFieldMapping[key],
                    value: getRadioFacetValue(key, sourceFilters[key])
                });
            }
        }
    });
};
var buildSnowplowFilterItems = function(filters, location, company) {
    var items = [];
    var modifiedFilters = (0,_object_spread/* default */.Z)({}, filters);
    if (location) {
        Object.assign(modifiedFilters, {
            location: [
                location
            ]
        });
    }
    if (filters.location && !location) {
        delete modifiedFilters.location;
    }
    if (company) {
        Object.assign(modifiedFilters, {
            company: [
                company
            ]
        });
    }
    if (filters.company && !company) {
        delete modifiedFilters.company;
    }
    Object.keys(modifiedFilters).forEach(function(key) {
        if (!snowplowFilterNameMap.get(key) || !modifiedFilters[key].length) return;
        if (Array.isArray(modifiedFilters[key])) {
            modifiedFilters[key].forEach(function(val) {
                items.push({
                    filter_name: snowplowFilterNameMap.get(key),
                    filter_value: val
                });
            });
        } else {
            items.push({
                filter_name: snowplowFilterNameMap.get(key),
                filter_value: modifiedFilters[key]
            });
        }
    });
    return items;
};

// EXTERNAL MODULE: ./src/components/facets/SearchFacets.module.scss
var SearchFacets_module = __webpack_require__(3223);
var SearchFacets_module_default = /*#__PURE__*/__webpack_require__.n(SearchFacets_module);
;// CONCATENATED MODULE: ./src/components/facets/jobs/JobFacets.tsx










var JobFacets = function(props) {
    var remoteIsSelected = props.remoteIsSelected, updateRemoteIsSelected = props.updateRemoteIsSelected, locationIsSelected = props.locationIsSelected, rest = (0,_object_without_properties/* default */.Z)(props, [
        "remoteIsSelected",
        "updateRemoteIsSelected",
        "locationIsSelected"
    ]);
    var remoteCheckboxFacetProps = {
        label: "Remote/Flexible Only",
        checked: remoteIsSelected,
        onChange: function() {
            updateRemoteIsSelected(remoteIsSelected);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFacets_module_default()).jobFilterSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (SearchFacets_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Text */.xv, {
                    htmlTag: "h2",
                    textStyle: "heading-3",
                    className: classnames_default()((SearchFacets_module_default()).headerText, (SearchFacets_module_default()).subHeaderText),
                    children: "Job Filters"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchFacets_module_default()).facetList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread/* default */.Z)({
                        fieldType: "radio",
                        userInputFilterName: "postedDateRange",
                        searchFilterItems: searchFacetItems/* postedDateRangeItems */.dK,
                        labelText: "Date Posted",
                        defaultValue: ""
                    }, rest)))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread/* default */.Z)({
                        fieldType: "checkbox",
                        userInputFilterName: "category",
                        searchFilterItems: searchFacetItems/* jobCategoryItems */.Y0,
                        labelText: "Job Category"
                    }, rest)))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread/* default */.Z)({
                        fieldType: "checkbox",
                        userInputFilterName: "experienceLevel",
                        searchFilterItems: searchFacetItems/* experienceLevelItems */.s,
                        labelText: "Experience Level"
                    }, rest)))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilterCheckbox */.Hv, (0,_object_spread/* default */.Z)({}, remoteCheckboxFacetProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread/* default */.Z)({
                        fieldType: "radio",
                        userInputFilterName: "radius",
                        searchFilterItems: searchFacetItems/* searchRadiusItems */.Z5,
                        labelText: "Search Radius",
                        defaultValue: ""
                    }, rest))), {
                        disabled: !locationIsSelected
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var jobs_JobFacets = (JobFacets);

;// CONCATENATED MODULE: ./src/components/facets/companies/CompanyFacets.tsx



/* eslint-disable camelcase */ 






var CompanyFacets = function(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var companyFacets = useSearchFacetsState().companyFacets;
    var industries = companyFacets.industries, perks_and_benefits = companyFacets.perks_and_benefits, diversity_and_inclusion_attributes = companyFacets.diversity_and_inclusion_attributes;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFacets_module_default()).companyFilterSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (SearchFacets_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Text */.xv, {
                    htmlTag: "h2",
                    textStyle: "heading-3",
                    className: classnames_default()((SearchFacets_module_default()).headerText, (SearchFacets_module_default()).subHeaderText),
                    children: "Company Filters"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchFacets_module_default()).facetList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        fieldType: "checkbox",
                        disableOnCompanySelect: true,
                        userInputFilterName: "industry",
                        searchFilterItems: (0,searchFacetItems/* convertToFacetItemsFormat */.Wi)(industries),
                        labelText: "Company Industry"
                    })))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        fieldType: "checkbox",
                        disableOnCompanySelect: true,
                        userInputFilterName: "companySize",
                        searchFilterItems: searchFacetItems/* companySizeItems */.NB,
                        labelText: "Company Size"
                    })))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        fieldType: "checkbox",
                        disableOnCompanySelect: true,
                        userInputFilterName: "perks",
                        searchFilterItems: (0,searchFacetItems/* convertPerksAndBeniftsToNestedFormat */.rb)(perks_and_benefits),
                        labelText: "Perks and Benefits"
                    })))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SearchFilter */.ay, (0,_object_spread/* default */.Z)({}, getFacetProps((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        fieldType: "checkbox",
                        disableOnCompanySelect: true,
                        userInputFilterName: "companyLeadership",
                        searchFilterItems: (0,searchFacetItems/* convertToFacetItemsFormat */.Wi)(diversity_and_inclusion_attributes),
                        labelText: "Diversity & Inclusion"
                    }))))
                ]
            })
        ]
    });
};
/* harmony default export */ var companies_CompanyFacets = (CompanyFacets);

;// CONCATENATED MODULE: ./src/components/facets/SearchFacets.tsx

















var SearchFacets = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var onClose = props.onClose, onFiltersChange = props.onFiltersChange;
    var ref5 = useSearchState(), company = ref5.company, location = ref5.location, filters = ref5.filters, userInteractions = ref5.userInteractions;
    var searchDispatch = useSearchDispatch();
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(filters), 2), selectedFiltersState = ref6[0], setselectedFiltersState = ref6[1];
    var searchResultsState = useSearchResultsState();
    var isRemoteType = (location === null || location === void 0 ? void 0 : (ref = location.userSelectedLocation) === null || ref === void 0 ? void 0 : ref.remote_work_location_type) === "virtual";
    react.useEffect(function() {
        var filterSource = "individual_filter";
        if ((userInteractions === null || userInteractions === void 0 ? void 0 : userInteractions.mobileClearAllClickedAt) || (userInteractions === null || userInteractions === void 0 ? void 0 : userInteractions.desktopClearAllClickedAt)) {
            filterSource = "clear_all_filters_button";
        } else if (userInteractions === null || userInteractions === void 0 ? void 0 : userInteractions.individualFilterClearedAt) {
            filterSource = "clear_individual_filter_button";
        }
        // Filter was applied if values in filters does not exist in selectedFiltersState
        trackFacets("Applied Filter", filterSource, filters, selectedFiltersState);
        // Filter was removed if values in selectedFiltersState does not exist in filters
        trackFacets("Removed Filter", filterSource, selectedFiltersState, filters);
        setselectedFiltersState(filters);
    }, [
        filters
    ]);
    var clearFilters = function() {
        searchDispatch({
            type: UserInteractionActionTypes.updateFilterInteraction,
            payload: (0,_define_property/* default */.Z)({}, (0,browser/* isMobile */.tq)() ? "mobileClearAllClickedAt" : "desktopClearAllClickedAt", Date.now())
        });
        searchDispatch({
            type: FiltersActionTypes.resetAllFilters
        });
        // Reset the remote checkbox is remote is selected
        if (isRemoteType) {
            searchDispatch({
                type: LocationActionTypes.resetLocation
            });
        }
        onFiltersChange === null || onFiltersChange === void 0 ? void 0 : onFiltersChange();
    };
    var filterCount = getSelectedFiltersCount(filters, location === null || location === void 0 ? void 0 : (ref1 = location.userSelectedLocation) === null || ref1 === void 0 ? void 0 : ref1.remote_work_location_type);
    var clearMessage = "Clear ".concat(filterCount, " filter").concat(filterCount > 1 ? "s" : "");
    var viewResultsCount = searchResultsState.totalCount >= 10000 ? "10,000+" : (0,strings/* formatNumberComma */.ai)(searchResultsState.totalCount);
    var viewResultsMessage = "View ".concat(viewResultsCount, " Result").concat(searchResultsState.totalCount > 1 ? "s" : "");
    var viewResultsOnClick = function() {
        onClose();
        if ((0,browser/* isMobile */.tq)()) {
            (0,browser/* toggleWindowFreeze */.LF)();
        }
    };
    var dispatchUpdateRemoteCheckbox = function(remoteIsSelected) {
        var payload = {
            userInputValue: "",
            userSelectedLocation: null
        };
        if (!remoteIsSelected) {
            payload = {
                userInputValue: "Remote / Flexible",
                userSelectedLocation: {
                    label: "Remote / Flexible",
                    value: "Remote / Flexible",
                    latitude: null,
                    longitude: null,
                    remote_work_location_type: "virtual"
                }
            };
        }
        searchDispatch({
            type: LocationActionTypes.updateLocation,
            payload: payload
        });
        if (filters === null || filters === void 0 ? void 0 : filters.radius) {
            searchDispatch({
                type: FiltersActionTypes.updateFilter,
                payload: {
                    radius: ""
                }
            });
        }
    };
    var locationIsSelected = !!(location === null || location === void 0 ? void 0 : (ref2 = location.userSelectedLocation) === null || ref2 === void 0 ? void 0 : ref2.value) && !!(location === null || location === void 0 ? void 0 : (ref3 = location.userSelectedLocation) === null || ref3 === void 0 ? void 0 : ref3.latitude) && !!(location === null || location === void 0 ? void 0 : (ref4 = location.userSelectedLocation) === null || ref4 === void 0 ? void 0 : ref4.longitude) && !isRemoteType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFacets_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: classnames_default()((SearchFacets_module_default()).mainHeader, (SearchFacets_module_default()).header),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Text */.xv, {
                        textStyle: "heading-3",
                        className: (SearchFacets_module_default()).headerText,
                        children: "All Filters"
                    }),
                    filterCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (SearchFacets_module_default()).headerButton,
                        onClick: clearFilters,
                        children: "Clear All"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(jobs_JobFacets, {
                filters: filters,
                company: company,
                dispatch: searchDispatch,
                remoteIsSelected: isRemoteType,
                updateRemoteIsSelected: dispatchUpdateRemoteCheckbox,
                locationIsSelected: locationIsSelected
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_CompanyFacets, {
                filters: filters,
                company: company,
                dispatch: searchDispatch
            }),
            filterCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (SearchFacets_module_default()).clearFacets,
                onClick: clearFilters,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* CloseIcon */.Tw, {
                        className: (SearchFacets_module_default()).clearFacetsIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Text */.xv, {
                        textStyle: "sans-serif-body-small",
                        htmlTag: "span",
                        className: (SearchFacets_module_default()).clearFacetsText,
                        children: clearMessage
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: (SearchFacets_module_default()).footer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
                    className: (SearchFacets_module_default()).viewResults,
                    color: "secondary-100",
                    onClick: viewResultsOnClick,
                    children: viewResultsMessage
                })
            })
        ]
    });
};
/* harmony default export */ var facets_SearchFacets = (SearchFacets);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(5666);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 3 modules
var downshift_esm = __webpack_require__(9194);
// EXTERNAL MODULE: ./src/orm/locations.ts
var locations = __webpack_require__(7248);
;// CONCATENATED MODULE: ./src/selectors/index.ts
var initialLocationList = [
    {
        label: "Remote / Flexible",
        value: "Remote / Flexible",
        latitude: null,
        longitude: null,
        remote_work_location_type: "virtual",
        id: 0
    },
    {
        label: "New York, NY",
        value: "New York, NY",
        latitude: 40.709999084472656,
        longitude: -74.01000213623047,
        remote_work_location_type: null,
        id: 5852770
    },
    {
        label: "San Francisco, CA",
        value: "San Francisco, CA",
        latitude: 37.77492904663086,
        longitude: -122.41941833496094,
        remote_work_location_type: null,
        id: 5834763
    },
    {
        label: "Los Angeles, CA",
        value: "Los Angeles, CA",
        latitude: 34.0522346496582,
        longitude: -118.24368286132812,
        remote_work_location_type: null,
        id: 5834138
    },
    {
        label: "Boston, MA",
        value: "Boston, MA",
        latitude: 42.36008071899414,
        longitude: -71.05888366699219,
        remote_work_location_type: null,
        id: 5845716
    },
    {
        label: "Washington, DC",
        value: "Washington, DC",
        latitude: 38.90719223022461,
        longitude: -77.03687286376953,
        remote_work_location_type: null,
        id: 5831724
    },
    {
        label: "Austin, TX",
        value: "Austin, TX",
        latitude: 30.267152786254883,
        longitude: -97.74305725097656,
        remote_work_location_type: null,
        id: 5862957
    },
    {
        label: "Chicago, IL",
        value: "Chicago, IL",
        latitude: 41.87811279296875,
        longitude: -87.62979888916016,
        remote_work_location_type: null,
        id: 5838173
    },
    {
        label: "Seattle, WA",
        value: "Seattle, WA",
        latitude: 47.60620880126953,
        longitude: -122.33206939697266,
        remote_work_location_type: null,
        id: 5865100
    },
    {
        label: "Atlanta, GA",
        value: "Atlanta, GA",
        latitude: 33.74899673461914,
        longitude: -84.38798522949219,
        remote_work_location_type: null,
        id: 5837145
    }
];
var selectedLocationSelector = function(location, company, userLocation) {
    var _lat = userLocation.lat, lat = _lat === void 0 ? null : _lat, _lon = userLocation.lon, lon = _lon === void 0 ? null : _lon;
    var userSelectedLocation = location.userSelectedLocation;
    var companySet = company.userSelectedCompany === null;
    var defaultInitialSearchLocation = {
        label: "",
        latitude: companySet ? lat : null,
        longitude: companySet ? lon : null,
        remote_work_location_type: null,
        value: ""
    };
    return (userSelectedLocation === null || userSelectedLocation.latitude === null) && (userSelectedLocation === null || userSelectedLocation === void 0 ? void 0 : userSelectedLocation.remote_work_location_type) !== "virtual" ? defaultInitialSearchLocation : userSelectedLocation;
};
var locationSuggestionsSelector = function(location) {
    var locationSuggestions = location.locationSuggestions;
    return (locationSuggestions === null || locationSuggestions === void 0 ? void 0 : locationSuggestions.length) ? locationSuggestions : initialLocationList;
};
var searchResultsSelector = function(searchState, userLocation) {
    var ref, ref1, ref2;
    var location = searchState.location, company = searchState.company, keyword = searchState.keyword, filters = searchState.filters, userInteractions = searchState.userInteractions, url = searchState.url, preference = searchState.preference, searchId = searchState.searchId;
    var searchResultsLocation = selectedLocationSelector(location, company, userLocation);
    var ref3;
    var locationName = (ref3 = searchResultsLocation === null || searchResultsLocation === void 0 ? void 0 : searchResultsLocation.value) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4 = searchResultsLocation || {}, latitude = ref4.latitude, longitude = ref4.longitude;
    // Checking for the userSelectedLocation value makes sure that the carmen location is not included in the request
    var latlng = (location === null || location === void 0 ? void 0 : (ref = location.userSelectedLocation) === null || ref === void 0 ? void 0 : ref.value) && latitude ? "".concat(latitude, ",").concat(longitude) : null;
    var remoteOption = searchResultsLocation === null || searchResultsLocation === void 0 ? void 0 : searchResultsLocation.remote_work_location_type;
    // Get company-derived parameters
    var companyName = (ref1 = company.userSelectedCompany) === null || ref1 === void 0 ? void 0 : ref1.label;
    var companyShortName = (ref2 = company.userSelectedCompany) === null || ref2 === void 0 ? void 0 : ref2.value;
    // Get category-derived parameters;
    var category = (filters === null || filters === void 0 ? void 0 : filters.category.length) === 1 ? filters === null || filters === void 0 ? void 0 : filters.category[0] : null;
    // Get keyword-derived parameters
    var searchKeyword = keyword.userInputValue;
    return {
        company: company,
        location: location,
        keyword: keyword,
        filters: filters,
        locationName: locationName,
        latitude: latitude,
        longitude: longitude,
        latlng: latlng,
        remoteOption: remoteOption,
        companyName: companyName,
        companyShortName: companyShortName,
        category: category,
        searchKeyword: searchKeyword,
        userInteractions: userInteractions,
        url: url,
        preference: preference,
        searchId: searchId
    };
};

// EXTERNAL MODULE: ./src/utils/api.ts
var api = __webpack_require__(1557);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./src/components/header/SearchInput.module.scss
var SearchInput_module = __webpack_require__(8619);
var SearchInput_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_module);
;// CONCATENATED MODULE: ./src/components/header/CompanySearchInput.tsx








var menuToggle = function(value) {
    var navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach(function(elem) {
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
var CompanySearchInput = function(props) {
    var company = props.company, clear = props.clear, onInputChange = props.onInputChange, noResultsMessage = props.noResultsMessage;
    var companySuggestions = company.companySuggestions, userSelectedCompany = company.userSelectedCompany;
    var placeHolderText = "All Companies";
    var dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconCompany */.yv, {}),
            dropdownList: companySuggestions,
            dropdownTitle: "Type to select a company",
            debounceWait: 200,
            labelText: "Companies",
            placeHolderText: placeHolderText,
            inputId: "company-input",
            maxLength: constants/* suggestionApiQueryMaxlength */.BU,
            onInputChange: onInputChange,
            onMenuToggle: menuToggle,
            clearValue: clear,
            fieldValue: userSelectedCompany,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage: noResultsMessage
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ComposableSearchDropdown */.V6, (0,_object_spread/* default */.Z)({}, dropdownProps));
};
CompanySearchInput.displayName = "CompanySearchInput";
/* harmony default export */ var header_CompanySearchInput = (CompanySearchInput);

;// CONCATENATED MODULE: ./src/components/header/KeywordSearchInput.tsx







var KeywordSearchInput_menuToggle = function(value) {
    var navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach(function(elem) {
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
var filterList = function(list) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return list.filter(function(item) {
        return item.label.toLowerCase().includes(value.toLowerCase());
    });
};
var KeywordSearchInput = function(props) {
    var keyword = props.keyword, clear = props.clear, onInputChange = props.onInputChange, noResultsMessage = props.noResultsMessage;
    var userSelectedKeyword = keyword.userSelectedKeyword, userInputValue = keyword.userInputValue;
    var keywordList = [
        {
            label: "Marketing",
            value: "marketing"
        },
        {
            label: "Sales",
            value: "sales"
        },
        {
            label: "Product Management",
            value: "product manager"
        },
        {
            label: "Design",
            value: "design"
        },
        {
            label: "Software Engineering",
            value: "software engineering"
        },
        {
            label: "Human Resources",
            value: "human resources"
        },
        {
            label: "Finance",
            value: "finance"
        },
        {
            label: "Project Management",
            value: "project management"
        },
        {
            label: "Customer Care",
            value: "customer care"
        },
        {
            label: "Data Entry",
            value: "data entry"
        },
        {
            label: "Account Manager",
            value: "account manager"
        },
        {
            label: "Accountant",
            value: "accountant"
        },
        {
            label: "Accounting",
            value: "accounting"
        },
        {
            label: "Actuary",
            value: "actuary"
        },
        {
            label: "Admin",
            value: "admin"
        },
        {
            label: "Administrative",
            value: "administrative"
        },
        {
            label: "Administrative Assistant",
            value: "administrative assistant"
        },
        {
            label: "Analyst",
            value: "analyst"
        },
        {
            label: "Analytics",
            value: "analytics"
        },
        {
            label: "Art",
            value: "art"
        },
        {
            label: "Art Director",
            value: "art director"
        },
        {
            label: "Assistant",
            value: "assistant"
        },
        {
            label: "Associate Consultant",
            value: "associate consultant"
        },
        {
            label: "Brand Manager",
            value: "brand manager"
        },
        {
            label: "Brand Marketing",
            value: "brand marketing"
        },
        {
            label: "Business",
            value: "business"
        },
        {
            label: "Business Analyst",
            value: "business analyst"
        },
        {
            label: "Business Development",
            value: "business development"
        },
        {
            label: "Chief Of Staff",
            value: "chief of staff"
        },
        {
            label: "Clinical Educator",
            value: "clinical educator"
        },
        {
            label: "Coach",
            value: "coach"
        },
        {
            label: "Communication",
            value: "communication"
        },
        {
            label: "Communications",
            value: "communications"
        },
        {
            label: "Community Health Worker",
            value: "community health worker"
        },
        {
            label: "Community Manager",
            value: "community manager"
        },
        {
            label: "Compensation And Benefits Manager",
            value: "compensation and benefits manager"
        },
        {
            label: "Compliance",
            value: "compliance"
        },
        {
            label: "Computer Programmer",
            value: "computer programmer"
        },
        {
            label: "Content",
            value: "content"
        },
        {
            label: "Content Marketing",
            value: "content marketing"
        },
        {
            label: "Content Marketing Manager",
            value: "content marketing manager"
        },
        {
            label: "Content Writer",
            value: "content writer"
        },
        {
            label: "Coordinator",
            value: "coordinator"
        },
        {
            label: "Copy Editor",
            value: "copy editor"
        },
        {
            label: "Copywriter",
            value: "copywriter"
        },
        {
            label: "Corporate Communications",
            value: "corporate communications"
        },
        {
            label: "Creative",
            value: "creative"
        },
        {
            label: "Creative Director",
            value: "creative director"
        },
        {
            label: "Curriculum Developer",
            value: "curriculum developer"
        },
        {
            label: "Customer",
            value: "customer"
        },
        {
            label: "Customer Service",
            value: "customer service"
        },
        {
            label: "Customer Service Representative",
            value: "customer service representative"
        },
        {
            label: "Customer Success",
            value: "customer success"
        },
        {
            label: "Customer Success Manager",
            value: "customer success manager"
        },
        {
            label: "Customer Support",
            value: "customer support"
        },
        {
            label: "Data",
            value: "data"
        },
        {
            label: "Data Analyst",
            value: "data analyst"
        },
        {
            label: "Data Entry Clerk",
            value: "data entry clerk"
        },
        {
            label: "Data Intern",
            value: "data intern"
        },
        {
            label: "Data Management Analyst",
            value: "data management analyst"
        },
        {
            label: "Data Science",
            value: "data science"
        },
        {
            label: "Data Science Manager",
            value: "data science manager"
        },
        {
            label: "Data Scientist",
            value: "data scientist"
        },
        {
            label: "Database Administrator",
            value: "database administrator"
        },
        {
            label: "Digital Marketing",
            value: "digital marketing"
        },
        {
            label: "Director",
            value: "director"
        },
        {
            label: "Diversity Manager",
            value: "diversity manager"
        },
        {
            label: "Editing",
            value: "editing"
        },
        {
            label: "Editor",
            value: "editor"
        },
        {
            label: "Editorial Assistant",
            value: "editorial assistant"
        },
        {
            label: "Education",
            value: "education"
        },
        {
            label: "Engineering",
            value: "engineering"
        },
        {
            label: "English Teacher",
            value: "english teacher"
        },
        {
            label: "Enterprise Sales Executive",
            value: "enterprise sales executive"
        },
        {
            label: "Entry Level",
            value: "entry level"
        },
        {
            label: "Environmental Restoration Planner",
            value: "environmental restoration planner"
        },
        {
            label: "Event",
            value: "event"
        },
        {
            label: "Executive",
            value: "executive"
        },
        {
            label: "Executive Assistant",
            value: "executive assistant"
        },
        {
            label: "Fashion",
            value: "fashion"
        },
        {
            label: "Financial Analyst",
            value: "financial analyst"
        },
        {
            label: "Financial Manager",
            value: "financial manager"
        },
        {
            label: "Graphic Design",
            value: "graphic design"
        },
        {
            label: "Graphic Designer",
            value: "graphic designer"
        },
        {
            label: "Health",
            value: "health"
        },
        {
            label: "Healthcare",
            value: "healthcare"
        },
        {
            label: "HR",
            value: "hr"
        },
        {
            label: "HR Associate",
            value: "hr associate"
        },
        {
            label: "HR Manager",
            value: "hr manager"
        },
        {
            label: "HRIS Manager",
            value: "hris manager"
        },
        {
            label: "Industrial Engineer",
            value: "industrial engineer"
        },
        {
            label: "Information Security Analyst",
            value: "information security analyst"
        },
        {
            label: "Information Technology",
            value: "information technology"
        },
        {
            label: "Insurance Sales Agent",
            value: "insurance sales agent"
        },
        {
            label: "Intern",
            value: "intern"
        },
        {
            label: "Internal Auditing Manager",
            value: "internal auditing manager"
        },
        {
            label: "Internship",
            value: "internship"
        },
        {
            label: "Internships",
            value: "internships"
        },
        {
            label: "Interpreter",
            value: "interpreter"
        },
        {
            label: "Interview",
            value: "interview"
        },
        {
            label: "Learning",
            value: "learning"
        },
        {
            label: "Learning And Development",
            value: "learning and development"
        },
        {
            label: "Learning And Development Specialist",
            value: "learning and development specialist"
        },
        {
            label: "Legal",
            value: "legal"
        },
        {
            label: "Loan Officer",
            value: "loan officer"
        },
        {
            label: "Management Consultant",
            value: "management consultant"
        },
        {
            label: "Manager",
            value: "manager"
        },
        {
            label: "Marketing Analyst",
            value: "marketing analyst"
        },
        {
            label: "Marketing Consultant",
            value: "marketing consultant"
        },
        {
            label: "Marketing Manager",
            value: "marketing manager"
        },
        {
            label: "Marketing Specialist",
            value: "marketing specialist"
        },
        {
            label: "Mechanical Engineer",
            value: "mechanical engineer"
        },
        {
            label: "Medical Device Sales",
            value: "medical device sales"
        },
        {
            label: "Medical Writer",
            value: "medical writer"
        },
        {
            label: "Mental Health",
            value: "mental health"
        },
        {
            label: "Nonprofit",
            value: "nonprofit"
        },
        {
            label: "Nonprofits",
            value: "nonprofits"
        },
        {
            label: "Operations",
            value: "operations"
        },
        {
            label: "Operations Research Analyst",
            value: "operations research analyst"
        },
        {
            label: "Paralegal",
            value: "paralegal"
        },
        {
            label: "Part Time",
            value: "part time"
        },
        {
            label: "Pharmaceutical Sales",
            value: "pharmaceutical sales"
        },
        {
            label: "Pharmacist",
            value: "pharmacist"
        },
        {
            label: "Pharmacy Technician",
            value: "pharmacy technician"
        },
        {
            label: "Physician Assistant",
            value: "physician assistant"
        },
        {
            label: "Policy Analyst",
            value: "policy analyst"
        },
        {
            label: "PR",
            value: "pr"
        },
        {
            label: "PR Manager",
            value: "pr manager"
        },
        {
            label: "Procurement",
            value: "procurement"
        },
        {
            label: "Product",
            value: "product"
        },
        {
            label: "Product Manager",
            value: "product manager"
        },
        {
            label: "Product Marketing",
            value: "product marketing"
        },
        {
            label: "Program Manager",
            value: "program manager"
        },
        {
            label: "Project",
            value: "project"
        },
        {
            label: "Project Manager",
            value: "project manager"
        },
        {
            label: "Proofreader",
            value: "proofreader"
        },
        {
            label: "Public Relations",
            value: "public relations"
        },
        {
            label: "Python",
            value: "python"
        },
        {
            label: "Real Estate",
            value: "real estate"
        },
        {
            label: "Recruiter",
            value: "recruiter"
        },
        {
            label: "Registered Nurse",
            value: "registered nurse"
        },
        {
            label: "Regulatory Affairs Manager",
            value: "regulatory affairs manager"
        },
        {
            label: "Remote",
            value: "remote"
        },
        {
            label: "Research",
            value: "research"
        },
        {
            label: "Research Analyst",
            value: "research analyst"
        },
        {
            label: "Sales Consultant",
            value: "sales consultant"
        },
        {
            label: "Sales Engineer",
            value: "sales engineer"
        },
        {
            label: "Sales Representative",
            value: "sales representative"
        },
        {
            label: "Salesforce",
            value: "salesforce"
        },
        {
            label: "School Counselor",
            value: "school counselor"
        },
        {
            label: "Scrum Master",
            value: "scrum master"
        },
        {
            label: "Security",
            value: "security"
        },
        {
            label: "Senior Product Management Director",
            value: "senior product management director"
        },
        {
            label: "Senior UX Designer",
            value: "senior ux designer"
        },
        {
            label: "SEO",
            value: "seo"
        },
        {
            label: "Social Media",
            value: "social media"
        },
        {
            label: "Social Media Coordinator",
            value: "social media coordinator"
        },
        {
            label: "Social Media Manager",
            value: "social media manager"
        },
        {
            label: "Social Worker",
            value: "social worker"
        },
        {
            label: "Software",
            value: "software"
        },
        {
            label: "Software Developer",
            value: "software developer"
        },
        {
            label: "Software Engineer",
            value: "software engineer"
        },
        {
            label: "Software Sales Executive",
            value: "software sales executive"
        },
        {
            label: "Solutions Architect",
            value: "solutions architect"
        },
        {
            label: "Strategy",
            value: "strategy"
        },
        {
            label: "Supply Chain",
            value: "supply chain"
        },
        {
            label: "Sustainability",
            value: "sustainability"
        },
        {
            label: "Teacher",
            value: "teacher"
        },
        {
            label: "Teaching Assistant",
            value: "teaching assistant"
        },
        {
            label: "Technical Writer",
            value: "technical writer"
        },
        {
            label: "Training",
            value: "training"
        },
        {
            label: "Translator",
            value: "translator"
        },
        {
            label: "Tutor",
            value: "tutor"
        },
        {
            label: "User Experience",
            value: "user experience"
        },
        {
            label: "UX",
            value: "ux"
        },
        {
            label: "UX Design",
            value: "ux design"
        },
        {
            label: "UX Designer",
            value: "ux designer"
        },
        {
            label: "UX Researcher",
            value: "ux researcher"
        },
        {
            label: "Video",
            value: "video"
        },
        {
            label: "Virtual Assistant",
            value: "virtual assistant"
        },
        {
            label: "Web Developer",
            value: "web developer"
        },
        {
            label: "Work From Home",
            value: "work from home"
        },
        {
            label: "Writer",
            value: "writer"
        },
        {
            label: "Writing",
            value: "writing"
        }, 
    ];
    var dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            dropdownList: filterList(keywordList, userInputValue),
            dropdownTitle: "Type to search for a job",
            onInputChange: onInputChange,
            inputId: "keyword-input",
            onMenuToggle: KeywordSearchInput_menuToggle,
            labelText: "Keyword",
            maxLength: constants/* jobSearchQueryMaxlength */.L8,
            clearValue: clear,
            fieldValue: userSelectedKeyword,
            noResultsMessage: noResultsMessage,
            placeHolderText: "Job title, keywords"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ComposableSearchDropdown */.V6, (0,_object_spread/* default */.Z)({}, dropdownProps));
};
KeywordSearchInput.displayName = "KeywordSearchInput";
/* harmony default export */ var header_KeywordSearchInput = (KeywordSearchInput);

;// CONCATENATED MODULE: ./src/components/header/LocationSearchInput.tsx








var LocationSearchInput_menuToggle = function(value) {
    var navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach(function(elem) {
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
var LocationSearchInput_filterList = function(list) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return list.filter(function(item) {
        var ref;
        return item === null || item === void 0 ? void 0 : (ref = item.label) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(value === null || value === void 0 ? void 0 : value.toLowerCase());
    });
};
var LocationSearchInput = function(props) {
    var location = props.location, clear = props.clear, onClear = props.onClear, onInputChange = props.onInputChange, noResultsMessage = props.noResultsMessage;
    var locationSuggestions = location.locationSuggestions, userSelectedLocation = location.userSelectedLocation, userInputValue = location.userInputValue;
    var placeHolderText = "Anywhere";
    var dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            dropdownList: LocationSearchInput_filterList(locationSuggestions, userInputValue),
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* LocationShape */.nD, {}),
            dropdownTitle: "Type to select a location",
            debounceWait: 200,
            labelText: "Locations",
            placeHolderText: placeHolderText,
            inputId: "location-input",
            maxLength: constants/* suggestionApiQueryMaxlength */.BU,
            onInputChange: onInputChange,
            onMenuToggle: LocationSearchInput_menuToggle,
            clearValue: clear,
            onClear: onClear,
            fieldValue: userSelectedLocation,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage: noResultsMessage
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ComposableSearchDropdown */.V6, (0,_object_spread/* default */.Z)({}, dropdownProps));
};
LocationSearchInput.displayName = "LocationSearchInput";
/* harmony default export */ var header_LocationSearchInput = (LocationSearchInput);

;// CONCATENATED MODULE: ./src/components/header/SearchInput.tsx






// eslint-disable-next-line import/no-extraneous-dependencies













var SearchButton = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* SquareButton */.LE, {
        className: (SearchInput_module_default()).inputSubmit,
        color: "secondary-100",
        onClick: onClick,
        children: "Search"
    });
};
var NoResults = function() {
    var onClearButtonClick = react.useContext(main/* DropdownContext */.Dl).onClearButtonClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "No matches. Please\xa0",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (SearchInput_module_default()).noResultsButton,
                onClick: onClearButtonClick,
                type: "button",
                children: "try another search."
            })
        ]
    });
};
var NoResultsKeyword = function() {
    var ref = react.useContext(main/* DropdownContext */.Dl), closeMenu = ref.closeMenu, inputValue = ref.inputValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (SearchInput_module_default()).noResultsButtonKeyword,
        onClick: closeMenu,
        type: "button",
        children: [
            'See all results for "',
            inputValue,
            '"'
        ]
    });
};
var SearchInput = function(props) {
    var ref, ref1;
    var clearInputs = props.clearInputs, onClear = props.onClear;
    var searchState = useSearchState();
    var searchDispatch = useSearchDispatch();
    var clearValues = function() {
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    var setLocationSuggestions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(locationInput) {
            var rawSuggestions, suggestions;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(typeof locationInput === "undefined")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return (0,api/* fetchLocationSuggestions */.gy)(locationInput);
                    case 4:
                        rawSuggestions = _ctx.sent;
                        suggestions = (0,locations/* formatLocations */.i)(rawSuggestions);
                        searchDispatch({
                            type: LocationActionTypes.updateLocationSuggestions,
                            payload: {
                                locationSuggestions: suggestions
                            }
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setLocationSuggestions(locationInput) {
            return _ref.apply(this, arguments);
        };
    }();
    var setCompanySuggestions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(companyInput) {
            var suggestions;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(typeof companyInput === "undefined")) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.next = 4;
                        return (0,api/* fetchCompanySuggestions */.SC)(companyInput);
                    case 4:
                        suggestions = _ctx.sent;
                        searchDispatch({
                            type: CompanyActionTypes.updateCompanySuggestions,
                            payload: {
                                companySuggestions: suggestions
                            }
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setCompanySuggestions(companyInput) {
            return _ref.apply(this, arguments);
        };
    }();
    react.useEffect(function() {
        var ref;
        setLocationSuggestions((ref = searchState.location) === null || ref === void 0 ? void 0 : ref.userInputValue);
    }, [
        (ref = searchState.location) === null || ref === void 0 ? void 0 : ref.userInputValue
    ]);
    react.useEffect(function() {
        var ref;
        setCompanySuggestions((ref = searchState.company) === null || ref === void 0 ? void 0 : ref.userInputValue);
    }, [
        (ref1 = searchState.company) === null || ref1 === void 0 ? void 0 : ref1.userInputValue
    ]);
    var updateLocationInput = function(changes) {
        var inputValue = changes.inputValue, selectedItem = changes.selectedItem, type = changes.type;
        // item was clicked from dropdown
        var itemClicked = type === downshift_esm/* useCombobox.stateChangeTypes.ItemClick */.Kb.stateChangeTypes.ItemClick;
        // reset button was clicked with menu open
        var resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        var resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        var inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        // user has entered a value into the input field
        var isEnteringData = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue !== "";
        if (isEnteringData || itemClicked) {
            searchDispatch({
                type: LocationActionTypes.updateLocation,
                payload: {
                    userInputValue: inputValue,
                    userSelectedLocation: selectedItem
                }
            });
        }
        if (itemClicked) {
            // set initial radius if not remote/flexible
            if (!(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.remote_work_location_type)) {
                searchDispatch({
                    type: FiltersActionTypes.updateFilter,
                    payload: {
                        radius: searchFacetItems/* initialRadiusValue */.kh
                    }
                });
            }
        }
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            var ref;
            searchDispatch({
                type: LocationActionTypes.updateLocation,
                payload: {
                    userInputValue: inputValue,
                    userSelectedLocation: null
                }
            });
            if (searchState === null || searchState === void 0 ? void 0 : (ref = searchState.filters) === null || ref === void 0 ? void 0 : ref.radius) {
                searchDispatch({
                    type: FiltersActionTypes.updateFilter,
                    payload: {
                        radius: ""
                    }
                });
            }
        }
    };
    var updateCompanyInput = function(changes) {
        var inputValue = changes.inputValue, selectedItem = changes.selectedItem;
        searchDispatch({
            type: CompanyActionTypes.updateCompany,
            payload: {
                userInputValue: inputValue,
                userSelectedCompany: selectedItem
            }
        });
        if (selectedItem) {
            searchDispatch({
                type: FiltersActionTypes.updateFilter,
                payload: {
                    industry: [],
                    perks: [],
                    companySize: []
                }
            });
        }
    };
    var updateKeywordInput = function(changes) {
        var inputValue = changes.inputValue, selectedItem = changes.selectedItem;
        // New keyword implementation
        searchDispatch({
            type: KeywordActionTypes.updateKeyword,
            payload: {
                userInputValue: inputValue,
                userSelectedKeyword: selectedItem
            }
        });
    };
    var onSearchButtonClick = function() {
        if (!(0,browser/* isMobile */.tq)()) {
            searchDispatch({
                type: UserInteractionActionTypes.updateFilterInteraction,
                payload: {
                    searchButtonClickedAt: Date.now()
                }
            });
        }
    };
    var formStyles = (SearchInput_module_default()).form;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: formStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_KeywordSearchInput, {
                    keyword: searchState.keyword,
                    clear: clearInputs,
                    onClear: clearValues,
                    onInputChange: updateKeywordInput,
                    noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultsKeyword, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_CompanySearchInput, {
                company: searchState.company,
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateCompanyInput,
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LocationSearchInput, {
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateLocationInput,
                location: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchState.location), {
                    locationSuggestions: locationSuggestionsSelector(searchState.location)
                }),
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                onClick: onSearchButtonClick
            })
        ]
    });
};
SearchInput.displayName = "SearchInput";
/* harmony default export */ var header_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./src/components/toggle/SearchFilterToggleBar.module.scss
var SearchFilterToggleBar_module = __webpack_require__(9793);
var SearchFilterToggleBar_module_default = /*#__PURE__*/__webpack_require__.n(SearchFilterToggleBar_module);
;// CONCATENATED MODULE: ./src/components/toggle/SearchFilterToggleBar.tsx








var SearchFilterToggleBar = function(props) {
    var ref;
    var onToggle = props.onToggle, open = props.open;
    var ref1 = useSearchState(), filters = ref1.filters, location = ref1.location;
    var selectedValuesCount = getSelectedFiltersCount(filters, location === null || location === void 0 ? void 0 : (ref = location.userSelectedLocation) === null || ref === void 0 ? void 0 : ref.remote_work_location_type);
    var filterButtonOnClick = function() {
        onToggle(!open);
        if ((0,browser/* isMobile */.tq)()) {
            (0,browser/* toggleWindowFreeze */.LF)();
        }
    };
    var filterButtonText = "Edit Filters ".concat(selectedValuesCount > 0 ? "(".concat(selectedValuesCount, ")") : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SearchFilterToggleBar_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(main/* SquareButton */.LE, {
            className: (SearchFilterToggleBar_module_default()).filterBtn,
            color: "white",
            onClick: filterButtonOnClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* IconFilter */.wH, {
                    className: (SearchFilterToggleBar_module_default()).filterBtnIcon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Text */.xv, {
                    textStyle: "sans-serif-body-small",
                    className: (SearchFilterToggleBar_module_default()).filterBtnText,
                    children: filterButtonText
                })
            ]
        })
    });
};
/* harmony default export */ var toggle_SearchFilterToggleBar = (SearchFilterToggleBar);

// EXTERNAL MODULE: ./node_modules/react-use/esm/useDebounce.js + 1 modules
var useDebounce = __webpack_require__(5386);
// EXTERNAL MODULE: ./node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(251);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
;// CONCATENATED MODULE: ./src/utils/searchResults.ts


/**
 * Convert an array to a string with commas.
 */ var joinIfArray = function(prop) {
    return Array.isArray(prop) ? prop.join(",") : prop;
};
/**
 * Collect the params from both the user inputs and the existing query string.
 * With User params taking precedents.
 * We do not collect the cursor as that is a special circumstance
 */ var getParams = function(param) {
    var filters = param.filters, companyShortName = param.companyShortName, searchKeyword = param.searchKeyword, remoteOption = param.remoteOption, latlng = param.latlng, cursor = param.cursor, searchApiPreference = param.searchApiPreference, _limit = param.limit, limit = _limit === void 0 ? 20 : _limit;
    var inputParams = {
        query: searchKeyword,
        company_short_name: companyShortName,
        level: joinIfArray(filters === null || filters === void 0 ? void 0 : filters.experienceLevel),
        employee_range: joinIfArray(filters === null || filters === void 0 ? void 0 : filters.companySize),
        latlng: latlng,
        remote_work_location_type: remoteOption,
        company_industry: joinIfArray(filters === null || filters === void 0 ? void 0 : filters.industry),
        perks_and_benefits: joinIfArray(filters === null || filters === void 0 ? void 0 : filters.perks),
        category: joinIfArray(filters === null || filters === void 0 ? void 0 : filters.category),
        radius: latlng ? filters === null || filters === void 0 ? void 0 : filters.radius : null,
        posted_date_range: filters === null || filters === void 0 ? void 0 : filters.postedDateRange,
        company_leadership_attributes: joinIfArray(filters === null || filters === void 0 ? void 0 : filters.companyLeadership),
        preference: searchApiPreference,
        limit: limit
    };
    // This should really not be here, we need to read this into state properly
    // const queryParams = parseQueryParamsToObject(window.location.search);
    var userParams = (0,reducers/* removeFalsy */.S)(inputParams);
    return (0,_object_spread/* default */.Z)({
        start_after: cursor
    }, userParams);
};

// EXTERNAL MODULE: ./src/orm/jobs.ts
var jobs = __webpack_require__(2919);
// EXTERNAL MODULE: ./src/components/content/Header.module.scss
var Header_module = __webpack_require__(463);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
;// CONCATENATED MODULE: ./src/components/content/Header.tsx




var SearchHeader = function(props) {
    var location = props.location, keyword = props.keyword, company = props.company, category = props.category, state = props.state;
    var total = state.totalCount;
    var headerStringObj = (0,strings/* getSearchSeoTitle */.Y8)(location, (0,strings/* unSlugify */.A$)(keyword), company, category, total);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
        className: (Header_module_default()).total,
        children: [
            total > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: headerStringObj.totalString
            }),
            headerStringObj.suffix
        ]
    });
};
SearchHeader.displayName = "SearchHeader";
/* harmony default export */ var Header = (SearchHeader);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowDownShape.tsx
var ArrowDownShape = __webpack_require__(8053);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./src/components/content/LoadMore.module.scss
var LoadMore_module = __webpack_require__(7686);
var LoadMore_module_default = /*#__PURE__*/__webpack_require__.n(LoadMore_module);
;// CONCATENATED MODULE: ./src/components/content/LoadMore.tsx




/**
 * Renders the load more button if there are in fact more results to get.
 */ var LoadMore = function(params) {
    var shouldLoad = params.shouldLoad, cb = params.cb;
    return shouldLoad ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
        className: (LoadMore_module_default()).loadMore,
        color: "secondary-100",
        onClick: cb,
        children: [
            "Load More Results",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownShape/* default */.Z, {})
        ]
    }) : null;
};
LoadMore.displayName = "LoadMore";


;// CONCATENATED MODULE: ./src/utils/cookies.ts
// These only work inside the browser

/**
 * Retrieve an existing cookie or an empty string.
 */ var get = function(name) {
    var r = document.cookie.match("\\b".concat(name, "=([^;]*)\\b"));
    return r ? r[1] : "";
};
/**
 * Set a cookie or replace an existing cookie.
 */ var set = function(name, value) {
    var days = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    if (!(0,browser/* isBrowser */.jU)()) {
        return "";
    }
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=".concat(date.toUTCString());
    }
    document.cookie = "".concat(name, "=").concat(value, ";expires=").concat(expires, ";path=/");
    return document.cookie;
};
/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */ var remove = function(name) {
    set(name, "", -1);
};
var Cookies = {
    remove: remove,
    get: get,
    set: set
};
/* harmony default export */ var cookies = (Cookies);

;// CONCATENATED MODULE: ./src/utils/externalJobApply.ts


var cookieKey = "external_job_ids_list";
/**
 * Retrieve and decode the job object from the cookie.
 */ var getJobObject = function() {
    var cookie = cookies.get(cookieKey);
    var decodedData = window.atob(cookie.toString());
    var jobObject = JSON.parse(decodedData || "{}");
    return jobObject;
};
/**
 * Inject a new job ID and dedupe the list.
 */ var updateJobList = function(list, id) {
    list.push(id);
    var newList = list.filter(function(x, index) {
        return list.indexOf(x) === index;
    });
    return newList;
};
/**
 * Creat or update the jobs object.
 */ var setJobObject = function(companyId, jobId) {
    var jobObject = getJobObject();
    jobObject[companyId] = jobObject[companyId] ? updateJobList(jobObject[companyId], jobId) : [
        jobId
    ];
    var encryptedJobs = window.btoa(JSON.stringify(jobObject));
    return encryptedJobs;
};
/**
 * Sets a cookie with the encrypted companies and jobs applied to by this session within the last 30 days.
 */ var externalJobApply = function(companyId, jobId) {
    if (!browser/* isBrowser */.jU) {
        return;
    }
    var jobObject = setJobObject(companyId, jobId);
    cookies.set(cookieKey, jobObject, 30);
};


;// CONCATENATED MODULE: ./src/components/content/JobTile.tsx



/* eslint-disable camelcase */ 







/**
 * Attempt to pull the closest matching location out of the job.
 */ var getJobTileLocation = function(props) {
    var inputDma = props.inputDma, locationType = props.locationType, locations = props.locations, sessionDma = props.sessionDma;
    var isRemote = locationType === "virtual";
    // We always prefer the dropdown if it was used.
    var userLocation = inputDma || sessionDma;
    // We Only care about the actual location address.
    var locationStrings = locations.map(function(location) {
        return location.address;
    });
    // This is the fully matched location (city and state).
    var matchedLocation = locationStrings.find(function(loc) {
        return loc === userLocation;
    });
    // We may need to match only on the last segment of the location.
    var getState = function(txt) {
        if (typeof txt === "string") {
            var ref, ref1;
            return (ref1 = (ref = txt.split(",")[1]) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    var matchedRegion = locationStrings.find(function(address) {
        return getState(address) === getState(userLocation);
    });
    // First location in the list (fall back)
    var firstLocation = locationStrings[0];
    // The location to display
    var displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    var locationWord = " location".concat(locationStrings.length > 2 ? "s" : "");
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    var extraLocations = locationStrings.length > 1 ? " + ".concat(locationStrings.length - 1).concat(locationWord) : "";
    // If we are remote and there is a location we will separate them with a slash.
    var separator = displayLocation ? " / " : "";
    // Build the remote string.
    var remoteString = isRemote ? "".concat(separator, "Remote") : "";
    // all together now...
    return [
        "".concat(displayLocation).concat(remoteString).concat(extraLocations)
    ];
};
/**
 * Generate the job apply link.
 */ var getJobTileApplyUrl = function(job) {
    var apply_type = job.apply_type, urlCompany = job.company, legacy_id = job.legacy_id, short_title = job.short_title;
    var short_name = urlCompany.short_name;
    return apply_type === "external" ? "/job/redirect/".concat(legacy_id) : "/jobs/".concat(short_name, "/").concat(short_title, "#apply-inline-form");
};
/**
 * Generates the tracking props for a card.
 * Returns an object.
 */ var getTrackingProps = function(job, viewJobHref, total, index, searchId) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,tracking/* genJobTrackingProps */.iR)(job)), {
        link_href: viewJobHref,
        total_results_on_page: total,
        placement: "search_results",
        order_num: index + 1,
        sp_tile_order: index + 1,
        sp_tile_search_id: searchId,
        sp_impression_search_id: searchId
    });
};
/**
 * Generates a callback for the card click.
 * Returns a function.
 */ var generateHandleCardClick = function(props, snowplowEventProps) {
    return function(event) {
        var viewJobHref = props.viewJobHref, trackingProps = props.trackingProps, cb = props.cb;
        // Only fire on clicking non anchor elements
        if (!(event.target instanceof HTMLAnchorElement)) {
            window.open(viewJobHref, "_blank");
            cb("Job Tile Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingProps), {
                click_type: "view_job_tile"
            }));
            (0,snowplow_js_client_build/* triggerSnowplowClickEvent */.jL)(snowplowEventProps);
        }
    };
};
/**
 * Generates a callback for the car right click.
 * Returns a function.
 */ var generateHandleCardRightClick = function(props) {
    return function(event) {
        var trackingProps = props.trackingProps, cb = props.cb;
        // Only fire on clicking non anchor elements
        if (!(event.target instanceof HTMLAnchorElement)) {
            cb("Job Tile Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingProps), {
                click_type: "view_job_tile"
            }));
        }
    };
};
/**
 * Generates a callback for the company name click.
 * Returns a function.
 */ var generateHandleCompanyNameClick = function(props) {
    return function() {
        var cb = props.cb, trackingProps = props.trackingProps;
        cb("Job Tile Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingProps), {
            click_type: "company_name_profile"
        }));
    };
};
/**
 * Generates a callback for the view job click.
 * Returns a function.
 */ var generateHandleViewJobClick = function(props, snowplowEventProps) {
    var cb = props.cb, trackingProps = props.trackingProps;
    return function() {
        cb("Job Tile Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingProps), {
            click_type: "view_job_button"
        }));
        (0,snowplow_js_client_build/* triggerSnowplowClickEvent */.jL)(snowplowEventProps);
    };
};
/**
 * Generates a callback for the apply now click.
 * Returns a function.
 */ var generateHandleApplyNowClick = function(props, snowplowEventProps) {
    var trackingProps = props.trackingProps, apply_type = props.apply_type, total = props.total, cb = props.cb;
    return function() {
        cb("Job Tile Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingProps), {
            click_type: "apply_now_button"
        }));
        cb("Job Apply Clicked", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, trackingProps), {
            job_type: apply_type,
            placement_position: "search results",
            total_results_on_page: total,
            click_type: "tile"
        }));
        externalJobApply(trackingProps.company_id.toString(), trackingProps.job_id);
        if ((0,browser/* isBrowser */.jU)() && typeof window.ga !== "undefined") {
            window.ga("send", {
                hitType: "event",
                eventCategory: "ExternalJob",
                eventAction: "job_tile_apply",
                nonInteraction: true
            });
        }
        (0,snowplow_js_client_build/* triggerSnowplowClickEvent */.jL)(snowplowEventProps);
    };
};
/**
 * Returns a fully formed and trackable job tile
 */ var JobTile = function(props) {
    var searchId = useSearchState().searchId;
    var job = props.job, index = props.index, inputDMA = props.inputDMA, userLocationDma = props.userLocationDma, total = props.total, _viewed = props.viewed, viewed = _viewed === void 0 ? false : _viewed, _showLogo = props.showLogo, showLogo = _showLogo === void 0 ? false : _showLogo, viewedCallback = props.viewedCallback;
    var ref;
    var ref1 = (ref = job === null || job === void 0 ? void 0 : job.hit) !== null && ref !== void 0 ? ref : {}, searchResultsCompany = ref1.company, apply_type = ref1.apply_type, id = ref1.id, snowplow_id = ref1.snowplow_id, legacy_id = ref1.legacy_id, locations = ref1.locations, short_title = ref1.short_title, title = ref1.title, posted_at = ref1.posted_at, remote_work_location_type = ref1.remote_work_location_type;
    var applyNowHref = getJobTileApplyUrl(job.hit);
    var companyHref = "/profiles/".concat(searchResultsCompany.short_name);
    var viewJobHref = "/jobs/".concat(searchResultsCompany.short_name, "/").concat(short_title);
    // always deal with dates on the client.
    var ref2 = (0,react.useState)(""), postedDate = ref2[0], setPostedDate = ref2[1];
    (0,react.useEffect)(function() {
        setPostedDate((0,strings/* formatDate */.p6)(new Date(posted_at * 1000)));
    });
    var trackingProps = getTrackingProps(job, viewJobHref, total, index, searchId);
    var tileLocation = getJobTileLocation({
        inputDma: inputDMA,
        locationType: remote_work_location_type,
        locations: locations,
        sessionDma: userLocationDma
    });
    var snowplowTileContentProps = {
        sp_tile_type: "job",
        sp_tile_company_id: searchResultsCompany.legacy_id.toString(),
        sp_tile_entity_id: legacy_id.toString(),
        sp_tile_entity_uuid: snowplow_id || id,
        sp_tile_location: null,
        sp_tile_order: index + 1
    };
    var handleCardClick = generateHandleCardClick({
        viewJobHref: viewJobHref,
        trackingProps: trackingProps,
        cb: tracking/* museTrack */.YU
    }, (0,_object_spread/* default */.Z)({
        sp_click_component: "tile",
        sp_click_component_tile_type: "job",
        sp_click_position: "main",
        sp_click_target_page_section: "job_detail",
        sp_click_search_id: searchId
    }, snowplowTileContentProps));
    var handleCardRightClick = generateHandleCardRightClick({
        trackingProps: trackingProps,
        cb: tracking/* museTrack */.YU
    });
    var handleCompanyNameClick = generateHandleCompanyNameClick({
        trackingProps: trackingProps,
        cb: tracking/* museTrack */.YU
    });
    var handleViewJobClick = generateHandleViewJobClick({
        trackingProps: trackingProps,
        cb: tracking/* museTrack */.YU
    }, (0,_object_spread/* default */.Z)({
        sp_click_component: "button",
        sp_click_component_tile_type: "job",
        sp_click_button_type: "job_view",
        sp_click_position: "main",
        sp_click_target_page_section: "job_detail",
        sp_click_search_id: searchId
    }, snowplowTileContentProps));
    // Apply on company site
    var handleApplyNowClick = generateHandleApplyNowClick({
        trackingProps: trackingProps,
        apply_type: apply_type,
        total: total,
        cb: tracking/* museTrack */.YU
    }, (0,_object_spread/* default */.Z)({
        sp_click_component: "button",
        sp_click_component_tile_type: "job",
        sp_click_button_type: "apply",
        sp_click_position: "main",
        sp_click_target_page_section: "off_site",
        sp_click_search_id: searchId
    }, snowplowTileContentProps));
    var jobCardProps = {
        showLogo: showLogo,
        companyName: searchResultsCompany.name,
        companyLogo: searchResultsCompany.logo,
        jobName: title,
        locations: tileLocation,
        companyHref: companyHref,
        applyNowHref: applyNowHref,
        postedDate: postedDate,
        viewJobHref: viewJobHref,
        onApplyNowClick: handleApplyNowClick,
        onViewJobClick: handleViewJobClick,
        onCompanyNameClick: handleCompanyNameClick,
        onCardClick: handleCardClick,
        onViewJobRightClick: handleViewJobClick,
        onApplyNowRightClick: handleApplyNowClick,
        onCompanyNameRightClick: handleCompanyNameClick,
        onCardRightClick: handleCardRightClick,
        isLazy: index > 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tracking/* TrackedElement */.cg, {
        eventName: "Job Tile Viewed",
        eventProps: trackingProps,
        enabled: !viewed,
        callback: viewedCallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* JobCard */.th, (0,_object_spread/* default */.Z)({}, jobCardProps), "card-".concat(id))
    }, "tracked-".concat(id));
};
JobTile.displayName = "JobTile";


// EXTERNAL MODULE: ./src/components/content/Empty.module.scss
var Empty_module = __webpack_require__(752);
var Empty_module_default = /*#__PURE__*/__webpack_require__.n(Empty_module);
;// CONCATENATED MODULE: ./src/components/content/Empty.tsx



/**
 * Uhho screen renders when there are zero results
 */ var Empty = function(params) {
    var requested = params.requested, results = params.results, cb = params.cb;
    return requested && !results ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Empty_module_default()).empty,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* EmptyResult */._f, {
            title: "Uh-oh.",
            details: "We couldn\u2019t find any jobs that match your search. Please try clearing all your filters, entering a new keyword, or searching in a different location.",
            buttonCta: "Clear my Search",
            onClick: cb
        })
    }) : null;
};
Empty.displayName = "Empty";


// EXTERNAL MODULE: ./src/components/content/Results.module.scss
var Results_module = __webpack_require__(7872);
var Results_module_default = /*#__PURE__*/__webpack_require__.n(Results_module);
;// CONCATENATED MODULE: ./src/components/content/Results.tsx







/* eslint-disable camelcase */ 



























/**
 * Extract the closest matching location out of a job and format it for display in a job tile.
 */ var Results_getJobTileLocation = function(props) {
    var inputDma = props.inputDma, locationType = props.locationType, locations = props.locations, sessionDma = props.sessionDma;
    var isRemote = locationType === "virtual";
    // We always prefer the dropdown if it was used.
    var userLocation = inputDma || sessionDma;
    // We Only care about the actual location address.
    var locationStrings = locations.map(function(location) {
        return location.address;
    });
    // This is the fully matched location (city and state).
    var matchedLocation = locationStrings.filter(function(loc) {
        return loc === userLocation;
    })[0];
    // We may need to match only on the last segment of the location.
    var getState = function(txt) {
        if (typeof txt === "string") {
            var ref, ref1;
            return (ref1 = (ref = txt.split(",")[1]) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    var matchedRegion = locationStrings.filter(function(address) {
        return getState(address) === getState(userLocation);
    })[0];
    // First location in the list (fall back)
    var firstLocation = locationStrings[0];
    // The location to display
    var displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    var locationWord = " location".concat(locationStrings.length > 2 ? "s" : "");
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    var extraLocations = locationStrings.length > 1 ? " + ".concat(locationStrings.length - 1).concat(locationWord) : "";
    // If we are remote and there is a location we will separate them with a slash.
    var separator = displayLocation ? " / " : "";
    // Build the remote string.
    var remoteString = isRemote ? "".concat(separator, "Remote") : "";
    // all together now...
    return [
        "".concat(displayLocation).concat(remoteString).concat(extraLocations)
    ];
};
var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
/**
 * Compiles the results tracking object.
 */ var setResultsTrackingObject = function(count, keyword, userSelectedLocation, companyShortName, filters, totalResultsOnPage, remoteOption) {
    return {
        source: "search-listing",
        filter_source: "search-listing",
        total_results: count,
        keyword: keyword !== null && keyword !== void 0 ? keyword : "",
        search_location: userSelectedLocation !== null && userSelectedLocation !== void 0 ? userSelectedLocation : "",
        company_short_name: companyShortName !== null && companyShortName !== void 0 ? companyShortName : "",
        filters: {
            experience_level: (ref = filters === null || filters === void 0 ? void 0 : filters.experienceLevel) !== null && ref !== void 0 ? ref : [],
            company_size: (ref1 = filters === null || filters === void 0 ? void 0 : filters.companySize) !== null && ref1 !== void 0 ? ref1 : [],
            remote_work_location_type: remoteOption,
            industry: (ref2 = filters === null || filters === void 0 ? void 0 : filters.industry) !== null && ref2 !== void 0 ? ref2 : [],
            perks_and_benefits: (ref3 = filters === null || filters === void 0 ? void 0 : filters.perks) !== null && ref3 !== void 0 ? ref3 : [],
            job_categories: (ref4 = filters === null || filters === void 0 ? void 0 : filters.category) !== null && ref4 !== void 0 ? ref4 : [],
            company_leadership: (ref5 = filters === null || filters === void 0 ? void 0 : filters.companyLeadership) !== null && ref5 !== void 0 ? ref5 : [],
            radius: userSelectedLocation ? getRadioFacetValue("radius", (ref6 = filters === null || filters === void 0 ? void 0 : filters.radius) !== null && ref6 !== void 0 ? ref6 : "") : "",
            date_posted: getRadioFacetValue("postedDateRange", (ref7 = filters === null || filters === void 0 ? void 0 : filters.postedDateRange) !== null && ref7 !== void 0 ? ref7 : "")
        },
        total_results_on_page: totalResultsOnPage
    };
};
/**
 * Renders a list of JobTile components based on the search results passed.
 */ var Tiles = function(props) {
    var searchResults = props.searchResults, locationName = props.locationName, userInteractions = props.userInteractions, userLocationDma = props.userLocationDma, resultsLength = props.resultsLength, searchDispatch = props.searchDispatch;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: searchResults.map(function(job, index) {
            var ref, ref1;
            var inputDMA = locationName !== null && locationName !== void 0 ? locationName : "";
            var viewed = userInteractions.tilesViewedJobIds.includes(job.hit.id);
            var ref2;
            var show_logo = ![
                "archived",
                "lite"
            ].includes((ref2 = job === null || job === void 0 ? void 0 : (ref = job.hit) === null || ref === void 0 ? void 0 : (ref1 = ref.company) === null || ref1 === void 0 ? void 0 : ref1.client_tier) !== null && ref2 !== void 0 ? ref2 : "");
            var handleViewedCallback = function(jobId) {
                searchDispatch({
                    type: UserInteractionActionTypes.updateJobTileViews,
                    payload: {
                        tilesViewedJobIds: [
                            jobId
                        ]
                    }
                });
            };
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTile, {
                job: job,
                index: index,
                inputDMA: inputDMA,
                userLocationDma: userLocationDma,
                total: resultsLength,
                viewed: viewed,
                showLogo: show_logo,
                viewedCallback: function() {
                    return handleViewedCallback(job.hit.id);
                }
            }, "".concat(job.hit.id));
        })
    });
};
Tiles.displayName = "Tiles";
/**
 * Render job search results and handling user interactions with the search results page.
 */ var Results = function(props) {
    var onClear = props.onClear;
    var ref = (0,config["default"])(), museWebHost = ref.publicRuntimeConfig.museWebHost;
    var ref1 = (0,UserContext/* useUserState */.e)(), userLocation = ref1.location;
    var ref2 = useWindowLocationState(), href = ref2.href, search = ref2.search;
    var searchDispatch = useSearchDispatch();
    var searchResultsState = useSearchResultsState();
    var totalCount = searchResultsState.totalCount, results = searchResultsState.results;
    var searchResultsDispatch = useSearchResultsDispatch();
    var ctsEnabled = useSearchState().ctsEnabled;
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), jobsHasBeenRequested = ref3[0], setJobsHasBeenRequested = ref3[1];
    /* eslint-disable-next-line no-unused-vars */ var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), userLocationDma = ref4[0], setUserLocationDma = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(!!(totalCount - results.length)), 2), hasMore = ref5[0], setHasMore = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState((Results_module_default()).resultsGrid), 2), classState = ref6[0], setClassState = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), initialLoad = ref7[0], setInitialLoad = ref7[1];
    var searchState = useSearchState();
    var ref8 = searchResultsSelector(searchState, userLocation), company = ref8.company, location = ref8.location, keyword = ref8.keyword, filters = ref8.filters, locationName = ref8.locationName, latitude = ref8.latitude, latlng = ref8.latlng, remoteOption = ref8.remoteOption, companyName = ref8.companyName, companyShortName = ref8.companyShortName, category = ref8.category, searchKeyword = ref8.searchKeyword, userInteractions = ref8.userInteractions, url = ref8.url, preference = ref8.preference, searchId = ref8.searchId;
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState({
        filters: filters,
        companyShortName: companyShortName,
        searchKeyword: searchKeyword,
        remoteOption: remoteOption,
        latlng: latlng,
        searchId: searchId
    }), 2), searchRequestState = ref9[0], setSearchRequestState = ref9[1];
    (0,useDebounce/* default */.Z)(function() {
        // Handle any updated search params
        var updatedSearchRequestState = {
            filters: filters,
            companyShortName: companyShortName,
            searchKeyword: searchKeyword,
            remoteOption: remoteOption,
            latlng: latlng,
            searchId: searchId
        };
        if (!deep_equal_default()(updatedSearchRequestState, searchRequestState)) {
            setSearchRequestState(updatedSearchRequestState);
        }
    }, 500, [
        company,
        location,
        keyword,
        filters
    ]);
    var router = (0,next_router.useRouter)() || {
        asPath: ""
    };
    var asPath = router.asPath;
    // This is the search id we want to use for tracking
    var uniqueSearchId = searchId;
    react.useEffect(function() {
        if (!(initialLoad && !!searchId)) {
            uniqueSearchId = (0,v4/* default */.Z)();
            searchDispatch({
                type: SearchIdActionTypes.updateSearchId,
                payload: uniqueSearchId
            });
        }
    }, [
        searchRequestState
    ]);
    react.useEffect(function() {
        // We load the first set of search results server
        // side, so we don't want to fetch on initial load.
        if (!initialLoad) {
            var urlPath = (0,browser/* generateUrlPath */.lT)({
                companyShortName: companyShortName,
                locationName: (0,strings/* normalizeLocationName */.DU)(locationName),
                searchKeyword: searchKeyword,
                filters: filters,
                asPath: asPath
            });
            fetchJobSearchResults();
            searchDispatch({
                type: UrlActionTypes.updateUrl,
                payload: urlPath
            });
        }
        (0,tracking/* museTrack */.YU)("Search Query Submitted", {
            search_origin: href,
            search_term: searchKeyword !== null && searchKeyword !== void 0 ? searchKeyword : "",
            search_location: locationName,
            search_company: companyName !== null && companyName !== void 0 ? companyName : "",
            search_company_short_name: companyShortName
        });
        var searchEventProps = {
            sp_search_type: "job",
            sp_search_id: uniqueSearchId,
            sp_search_keyword: searchKeyword
        };
        var isRemote = remoteOption === "virtual";
        var snowplowFilters = buildSnowplowFilterItems(filters, locationName, companyShortName);
        (0,snowplow_js_client_build/* triggerSnowplowSearchEvent */.Eg)(searchEventProps, snowplowFilters, isRemote);
    }, [
        searchRequestState,
        userInteractions === null || userInteractions === void 0 ? void 0 : userInteractions.searchButtonClickedAt
    ]);
    react.useEffect(function() {
        if (initialLoad) {
            setInitialLoad(false);
            return;
        }
        (0,tracking/* museTrack */.YU)("Search Results Returned", setResultsTrackingObject(searchResultsState.totalCount, searchKeyword, locationName, companyShortName, filters, searchResultsState.results.length, remoteOption));
    }, [
        searchResultsState
    ]);
    /**
     * Fetch jobs with an optional cursor Id.
     *
     * @param cursor This is the cursor within the last job on the page.
     * @returns Promise
     */ var fetchJobSearchResults = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(cursor) {
            var queryParams, jobsResponse, dispatchValues, count, hits;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setJobsHasBeenRequested(false);
                        // if this is not a load more request and we are scrolled at all, snap back to the top.
                        // TODO: There are no tests for this as JSDom does not expose scrollTo nor does it measure the physical DOM.
                        if (!cursor && window.scrollY) {
                            window.scrollTo(0, 0);
                        }
                        queryParams = getParams({
                            filters: filters,
                            companyShortName: companyShortName,
                            searchKeyword: searchKeyword,
                            remoteOption: remoteOption,
                            latlng: latlng,
                            cursor: cursor,
                            searchApiPreference: preference
                        });
                        _ctx.next = 5;
                        return (0,api/* fetchJobs */.bG)(queryParams, ctsEnabled);
                    case 5:
                        jobsResponse = _ctx.sent;
                        dispatchValues = (0,jobs/* formatJobsResponse */.n)(jobsResponse);
                        count = jobsResponse.count, hits = jobsResponse.hits;
                        searchResultsDispatch({
                            type: "update_results",
                            payload: {
                                values: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, dispatchValues), {
                                    results: cursor ? (0,_to_consumable_array/* default */.Z)(searchResultsState.results).concat((0,_to_consumable_array/* default */.Z)(hits)) : (0,_to_consumable_array/* default */.Z)(hits)
                                })
                            }
                        });
                        setJobsHasBeenRequested(true);
                        setHasMore(count - hits.length > 0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchJobSearchResults(cursor) {
            return _ref.apply(this, arguments);
        };
    }();
    /**
     * Clear all the search filters
     */ var clearSearch = function() {
        searchDispatch({
            type: FiltersActionTypes.resetAllFilters
        });
        searchDispatch({
            type: CompanyActionTypes.resetCompany
        });
        searchDispatch({
            type: LocationActionTypes.resetLocation
        });
        searchDispatch({
            type: KeywordActionTypes.resetKeyword
        });
        onClear === null || onClear === void 0 ? void 0 : onClear();
    };
    /**
     * This is the event fired by the load more button.
     * @param event:  The click event.
     */ var handleLoadMoreClick = function(event) {
        (0,tracking/* museTrack */.YU)("Pagination Link Clicked", {
            source: "search-listings",
            name: "load_more_results"
        });
        if (event) {
            event.preventDefault();
        }
        fetchJobSearchResults(searchResultsState.cursor);
    };
    /**
     * setUserLocationDma are triggered when any of the following are modified:
     * userInputs location lat changes
     */ react.useEffect(function() {
        setUserLocationDma(userLocation === null || userLocation === void 0 ? void 0 : userLocation.dma);
    }, [
        latitude
    ]);
    /**
     * Update the url
     */ react.useEffect(function() {
        if (typeof url !== "undefined") {
            window.history.replaceState(null, null, "".concat(url).concat(search));
        }
    }, [
        url
    ]);
    react.useEffect(function() {
        var classes = classnames_default()(hasMore ? (Results_module_default()).hasFade : false, (Results_module_default()).resultsGrid);
        setClassState(classnames_default()(jobsHasBeenRequested || initialLoad ? null : (Results_module_default()).shimmer, classes));
    }, [
        hasMore,
        jobsHasBeenRequested
    ]);
    var ref10;
    var searchResults = (ref10 = searchResultsState === null || searchResultsState === void 0 ? void 0 : searchResultsState.results) !== null && ref10 !== void 0 ? ref10 : [];
    var _length;
    var resultsLength = (_length = searchResults.length) !== null && _length !== void 0 ? _length : 0;
    var getLDJson = function(list) {
        var itemListElement = list.map(function(job, index) {
            var ref, ref1;
            var ref2;
            var ref3 = (ref2 = job === null || job === void 0 ? void 0 : job.hit) !== null && ref2 !== void 0 ? ref2 : {}, apply_type = ref3.apply_type, short_title = ref3.short_title;
            var extension = apply_type === "external" ? "" : "#apply-inline-form";
            return {
                "@type": "ListItem",
                position: index + 1,
                url: "".concat(museWebHost, "/jobs/").concat(job === null || job === void 0 ? void 0 : (ref = job.hit) === null || ref === void 0 ? void 0 : (ref1 = ref.company) === null || ref1 === void 0 ? void 0 : ref1.short_name, "/").concat(short_title).concat(extension)
            };
        });
        return JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            itemListElement: itemListElement
        });
    };
    var tilesProps = {
        searchResults: searchResults,
        locationName: locationName,
        userInteractions: userInteractions,
        userLocationDma: userLocationDma,
        resultsLength: resultsLength,
        searchDispatch: searchDispatch
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                state: searchResultsState,
                location: locationName !== null && locationName !== void 0 ? locationName : null,
                keyword: searchKeyword !== null && searchKeyword !== void 0 ? searchKeyword : null,
                company: companyName !== null && companyName !== void 0 ? companyName : null,
                category: category
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    // using old style script and head so that this script will update on filter change.
                    type: "application/ld+json",
                    id: "ItemList",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: getLDJson(searchResults)
                    }
                })
            }),
            resultsLength ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classState,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles, (0,_object_spread/* default */.Z)({}, tilesProps)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore, {
                        shouldLoad: hasMore,
                        cb: handleLoadMoreClick
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {
                requested: jobsHasBeenRequested,
                results: resultsLength,
                cb: clearSearch
            })
        ]
    });
};
Results.displayName = "Results";
/* harmony default export */ var content_Results = (Results);


;// CONCATENATED MODULE: ./src/components/content/SearchPageLayout.tsx




/* eslint-disable camelcase */ 








var SearchPageLayout = function() {
    var user = (0,UserContext/* useUserState */.e)();
    var pageLayoutProps = {
        activePath: "/search",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        user: user
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), filterOpen = ref[0], setFilterOpen = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), clearInputs = ref1[0], setClearInputs = ref1[1];
    var handleClose = function() {
        setFilterOpen(false);
    };
    var clearSearch = function() {
        setClearInputs(true);
    };
    var inputsCleared = function() {
        setClearInputs(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(main/* PageLayout */.Xg, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageLayoutProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (Home_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_SearchInput, {
                    clearInputs: clearInputs,
                    onClear: inputsCleared
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (Home_module_default()).filterToggle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_SearchFilterToggleBar, {
                    open: filterOpen,
                    onToggle: function(open) {
                        return setFilterOpen(open);
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                className: classnames_default()((Home_module_default()).sidebar, filterOpen ? (Home_module_default()).showSidebar : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facets_SearchFacets, {
                    onClose: handleClose,
                    onFiltersChange: function() {
                        return undefined;
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                className: (Home_module_default()).content,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(content_Results, {
                    onClear: clearSearch
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/pages/index.tsx





















var __N_SSP = true;
var getInitialFilterParams = function(params) {
    return Object.keys(params).reduce(function(values, currentValue) {
        var localValues = values;
        if (![
            "location",
            "company"
        ].includes(currentValue)) {
            var decodedParamValue = decodeURIComponent(params[currentValue]);
            // Format keyword
            var value = decodedParamValue;
            if (currentValue === "keyword") {
                value = (0,strings/* titleCase */.Qs)(value.replace(/\+/g, " "));
            }
            localValues[currentValue] = value;
        }
        return localValues;
    }, {});
};
var getInitialSearchId = function(reqUrl, reqHost) {
    var parsedUrl = new URL(reqUrl || "", "http://".concat(reqHost || "www.example.com"));
    var searchIdValue = parsedUrl.searchParams.get("_search_id");
    return searchIdValue || (0,v4/* default */.Z)();
};
var setInitialSearchState = function(initialSearchParams, companyAttributes, initialDropDownCompanies, carmenLocation, ctsEnabled) {
    var _location = initialSearchParams.location, location = _location === void 0 ? null : _location, _company = initialSearchParams.company, company = _company === void 0 ? null : _company, _keyword = initialSearchParams.keyword, keyword = _keyword === void 0 ? "" : _keyword, _category = initialSearchParams.category, category = _category === void 0 ? "" : _category, _industry = initialSearchParams.industry, industry = _industry === void 0 ? "" : _industry, _level = initialSearchParams.level, level = _level === void 0 ? "" : _level, _perks = initialSearchParams.perks, perks = _perks === void 0 ? "" : _perks, _size = initialSearchParams.size, size = _size === void 0 ? "" : _size, _radius = initialSearchParams.radius, radius = _radius === void 0 ? "" : _radius, tmp = initialSearchParams["date-posted"], postedDateRange = tmp === void 0 ? "" : tmp, tmp1 = initialSearchParams["company-leadership"], companyLeadership = tmp1 === void 0 ? "" : tmp1, _preference = initialSearchParams.preference, preference = _preference === void 0 ? "" : _preference, _searchId = initialSearchParams.searchId, searchId = _searchId === void 0 ? "" : _searchId;
    var diversity_and_inclusion_attributes = companyAttributes.diversity_and_inclusion_attributes, industries = companyAttributes.industries, perks_and_benefits = companyAttributes.perks_and_benefits;
    var foundSeniorLevel = false;
    var experienceLevel = level.split(",").map(function(levelValue) {
        if ([
            "senior",
            "management"
        ].includes(levelValue)) {
            if (foundSeniorLevel) {
                return "";
            }
            foundSeniorLevel = true;
            return "senior,management";
        }
        return levelValue;
    }).filter(function(levelValue) {
        return !!levelValue;
    });
    var radiusValues = getFacetValuesFromFacetItems(radius, searchFacetItems/* searchRadiusItems */.Z5);
    var ref;
    var initialRadius = location ? (ref = radiusValues[0]) !== null && ref !== void 0 ? ref : "" : "";
    var postedDateRangeValues = getFacetValuesFromFacetItems(postedDateRange, searchFacetItems/* postedDateRangeItems */.dK);
    var ref1;
    var initialPostedDateRange = (ref1 = postedDateRangeValues[0]) !== null && ref1 !== void 0 ? ref1 : "";
    return {
        location: location ? {
            userInputValue: location.label,
            userSelectedLocation: {
                label: location.label === "Flexible / Remote" ? "Remote / Flexible" : location.label,
                latitude: location.latitude,
                longitude: location.longitude,
                remote_work_location_type: location.label === "Remote / Flexible" || location.label === "Flexible / Remote" ? "virtual" : "",
                value: location.value === "Flexible / Remote" ? "Remote / Flexible" : location.value
            }
        } : {
            userInputValue: "",
            userSelectedLocation: {
                label: "",
                latitude: company ? null : (carmenLocation === null || carmenLocation === void 0 ? void 0 : carmenLocation.lat) || null,
                longitude: company ? null : (carmenLocation === null || carmenLocation === void 0 ? void 0 : carmenLocation.lon) || null,
                value: ""
            }
        },
        company: company ? {
            userSelectedCompany: {
                label: company.name,
                value: company.shortname
            },
            companySuggestions: initialDropDownCompanies
        } : {},
        keyword: {
            userInputValue: keyword || "",
            userSelectedKeyword: {
                label: keyword || "",
                value: keyword || ""
            }
        },
        filters: {
            experienceLevel: experienceLevel,
            category: getFacetValuesFromFacetItems(category, searchFacetItems/* jobCategoryItems */.Y0),
            industry: getFacetValuesFromFacetItems(industry, (0,searchFacetItems/* convertToFacetItemsFormat */.Wi)(industries)),
            perks: getFacetValuesFromFacetItems(perks, (0,searchFacetItems/* convertToFacetItemsFormat */.Wi)((0,searchFacetItems/* flattenPerksAndBenefits */.sg)(perks_and_benefits))),
            companyLeadership: getFacetValuesFromFacetItems(companyLeadership, (0,searchFacetItems/* convertToFacetItemsFormat */.Wi)(diversity_and_inclusion_attributes)),
            companySize: (size === null || size === void 0 ? void 0 : size.length) ? decodeURIComponent(size).split(",") : [],
            radius: initialRadius,
            postedDateRange: initialPostedDateRange
        },
        preference: preference,
        searchId: searchId,
        ctsEnabled: ctsEnabled
    };
};
var SnowplowInit = function() {
    var user = (0,UserContext/* useUserState */.e)();
    var publicRuntimeConfig = (0,config["default"])().publicRuntimeConfig;
    var ref = (0,react.useState)(false), pageViewTriggered = ref[0], setPageViewTriggered = ref[1];
    (0,react.useEffect)(function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            sp_page_is_external: false,
            sp_page_section: "search",
            sp_page_sponsor_id: null,
            sp_page_tab: null,
            sp_page_type: "collection",
            sp_experiment_experiment_id: "",
            sp_experiment_variant_id: ""
        });
        if (publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.snowplowCollector) {
            (0,snowplow_js_client_build/* initSnowplowTracker */.Jg)(publicRuntimeConfig.snowplowCollector);
        }
    }, []);
    react.useEffect(function() {
        var _logged_in;
        window.sp_user_logged_in = (_logged_in = user.logged_in) !== null && _logged_in !== void 0 ? _logged_in : false;
        var _id;
        window.sp_user_id = (_id = user.id) !== null && _id !== void 0 ? _id : null;
    }, [
        user
    ]);
    // Note: Add snowplow pageview in a useEffect??
    // After a user api request attempt has been made??
    react.useEffect(function() {
        if (user.isInitialized && !pageViewTriggered) {
            (0,snowplow_js_client_build/* triggerSnowplowPageViewEvent */.y)();
            setPageViewTriggered(true);
        }
    }, [
        user
    ]);
    return null;
};
var OskarUserInit = function() {
    var user = (0,UserContext/* useUserState */.e)();
    react.useEffect(function() {
        // NOTE: An email with `themuse.com` does not mean the user is an admin
        var isMuser = (user === null || user === void 0 ? void 0 : user.email) && user.email.split("@")[1] === "themuse.com";
        var _logged_in, _id;
        (0,tracking/* userTrack */.Uk)({
            signed_in: (_logged_in = user.logged_in) !== null && _logged_in !== void 0 ? _logged_in : false,
            is_muser: isMuser,
            is_admin: isMuser,
            user_id: (_id = user.id) !== null && _id !== void 0 ? _id : null
        });
    }, [
        user
    ]);
    return null;
};
var Home = function(props) {
    var initialSearchState = props.initialSearchState, initialSearchResultsState = props.initialSearchResultsState, experiments = props.experiments, carmenLocation = props.carmenLocation, companyAttributes = props.companyAttributes, featureFlags = props.featureFlags;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(build.ExperimentProvider, {
        experiments: experiments,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext/* UserProvider */.d, {
            userLocation: carmenLocation,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsProvider, {
                featureFlags: featureFlags,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFacetsProvider, {
                    companyFacets: companyAttributes,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchProvider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialSearchState), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WindowLocationProvider, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultsProvider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialSearchResultsState), {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowplowInit, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OskarUserInit, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo, {
                                        searchUrl: asPath
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageLayout, {})
                                ]
                            }))
                        })
                    }))
                })
            })
        })
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__FTeFV"};

/***/ }),

/***/ 463:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"total":"Header_total__0AoR2"};

/***/ }),

/***/ 7686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"LoadMore_loadMore__Gi4JP"};

/***/ }),

/***/ 7872:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resultsGrid":"Results_resultsGrid__rC3XV","hasFade":"Results_hasFade__Uulu_","shimmer":"Results_shimmer__F_Cbi","shimmerKeyFrame":"Results_shimmerKeyFrame__gW2Jk"};

/***/ }),

/***/ 3223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFacets_container___Jc6E","header":"SearchFacets_header__6_Q7a","mainHeader":"SearchFacets_mainHeader__x0U55","headerText":"SearchFacets_headerText__zd1S_","subHeaderText":"SearchFacets_subHeaderText__F9Rmp","headerButton":"SearchFacets_headerButton__1SzQE","facet":"SearchFacets_facet__w8n_2","facetList":"SearchFacets_facetList__DuDK0","facetButton":"SearchFacets_facetButton___TFbI","footer":"SearchFacets_footer__AY6FW","clearFacets":"SearchFacets_clearFacets__zYutE","clearFacetsIcon":"SearchFacets_clearFacetsIcon__no2Lv","clearFacetsText":"SearchFacets_clearFacetsText__TCNDt","viewResults":"SearchFacets_viewResults__LRYx4"};

/***/ }),

/***/ 8619:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchInput_form__SSK4O","inputSubmit":"SearchInput_inputSubmit__iTw2G","inputIcon":"SearchInput_inputIcon__NNp1D","searchInputContainer":"SearchInput_searchInputContainer__iYKqt","noResultsButton":"SearchInput_noResultsButton__CNbU_","noResultsButtonKeyword":"SearchInput_noResultsButtonKeyword__J6EXM"};

/***/ }),

/***/ 9793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFilterToggleBar_container__S9_9K","filterBtn":"SearchFilterToggleBar_filterBtn__TgHdr","filterBtnIcon":"SearchFilterToggleBar_filterBtnIcon__VNglz","filterBtnText":"SearchFilterToggleBar_filterBtnText__XCyLR"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","pageHeader":"Home_pageHeader__Y8w6l","header":"Home_header__6KCIB","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","content":"Home_content__f1lUf","filterToggle":"Home_filterToggle__N96mk"};

/***/ }),

/***/ 4654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [989,417,992,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);